import React, { createRef } from "react";
import { FormikTextField } from "../../CommonComponents/FormField.js";
import { Autocomplete, Backdrop, CircularProgress, Grid, Input, InputAdornment, } from "@mui/material";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import {
  address,
  address2,
  ccity,
  ccountry,
  clientname,
  contactnumber,
  cstate,
  cstatecode,
  currency,
  currentTenant,
  czip,
  dataaccess,
  einvoice,
  financialyearend,
  financialyearstart,
  taxtype,
  thousandsdisplay,
  transactionFrom,
  userid,
  userwhid,
} from "../../Common/Credentials.js";
import { FieldArray, Form, Formik } from "formik";
import SalesServices from "../SalesServices";
import downloadfiles from "../../Common/upload/downloadfiles.js";
import { NumericFormat } from "react-number-format";
import {
  Box,
  Checkbox,
  Collapse,
  FormControlLabel,
  Tooltip,
  FormGroup,
  FormLabel,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import EditIcon from "../../images/Icons/edit.png";
import DeleteIcon from "../../images/Icons/delete.png";
import moment from "moment";
import { Modal, Spinner } from "react-bootstrap";
import InventoryService from "../../inventory/InventoryService.js";
import SettingsServices from "../../Settings/SettingsServices.js";
import MasterService from "../../Masters/MasterService.js";
import UsercustomerService from "../../Masters/Usercustomers/UsercustomerService.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import TransporterServices from "../../Masters/Transporter/TransporterServices.js";
import CategoryServices from "../../Masters/Category/CategoryServices.js";
import WarehouseServices from "../../Masters/Warehouse/WarehouseServices.js";
import IOSSwitch from "../../CommonComponents/IOSSwitch.js";
import CustomerService from "../../Masters/Customers/CustomerService.js";
import { DateTimePicker, DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DepartmentServices from "../../Masters/Department/DepartmentServices.js";
import { OSSwitch } from "../../NewUI/NewComponents/OSSwitch.jsx";
import { SelectableRadio } from "../../NewUI/NewComponents/SelectableRadio.jsx";
import UomServices from "../../Masters/Uom/UomServices.js";
import dayjs from 'dayjs';
import { isValid } from "date-fns";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";
import TextFeildWithSelect from "../../NewUI/NewComponents/TextFeildWithSelect.jsx";
import AutoCompeteField from "../../NewUI/NewComponents/AutoCompeteField.jsx";
import TextareaField from "../../NewUI/NewComponents/TextareaField.jsx";
import TaxServices from "../../Masters/Tax/TaxServices.js";
import SelectField from "../../NewUI/NewComponents/SelectField.jsx";
import RoundedTabButton from "../../NewUI/NewComponents/RoundedTabButton.jsx";
import DatePickerField from "../../NewUI/NewComponents/DatePickerField.jsx";

let datalist = [];
const isInvalid = ["", 0, "0", null, "null", NaN, "NaN", undefined]
class NonInvInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.mySectionRef = createRef();
    this.state = {
      invtype: "NonInventory",
      UOMList: [],
      invid: this.props.location.state.id,
      pagename: this.props.location.state.pagename,
      invNumber: 0,
      finacialLatestInvoiceNumber: null,
      saleorderdata: [],
      usercustomers: [],
      saleorderid: "",
      saleorderitems: [],
      taxesList: [],
      custom: [],
      customer: "",
      custid: "",
      agent: "",
      agentid: "",
      customerdetails: "",
      debitamount: 0,
      openingbalance: 0,
      adjustdebit: false,
      adjustopen: false,
      itemid: "",
      itemname: "",
      salesenum: "LIFO",
      quantity: 0,
      orderedquantity: "",
      pendingquantity: "",
      grandtotal: 0,
      ccgrandtotal: 0,
      status: "0",
      sodata: "",
      addservice: false,
      serviceList: [],
      milestones: [],
      contracttype: "",
      DnIDList: [],
      dndata: "",
      dnid: "",
      completed: "",
      backdateinvoicestatus: false,
      sotype: 0,
      show: 0,
      open: false,
      open1: false,
      openDuePicker: false,
      openCustomPicker: false,
      po: "",
      accepteditems: [],
      loader: false,
      creditperiod: 0,
      serviceid: "",
      currencylist: [],
      currencyid: "",
      currency: "",
      curconversionrate: 1,
      invtotalamountwtax: 0,
      ccinvtotalamountwtax: 0,
      tcsreq: false,
      tcs: 0,
      tcsamount: 0,
      whdata: [],
      itemquantitylist: [],
      batchidlist: [],
      batchid: "",
      quantitywindow: false,
      pouploadm: "",
      vehiclenum: null,
      distance: 0,
      transporterid: null,
      name: "",
      phoneno: "",
      pincode: "",
      state: "",
      statecode: "",
      city: "",
      houseno: "",
      areaname: "",
      country: "",
      disname: "",
      disphoneno: "",
      dispincode: "",
      disstate: "",
      disstatecode: "",
      discity: "",
      dishouseno: "",
      disareaname: "",
      discountry: "",
      err: false,
      adderr: false,
      CountryData: [],
      StatesData: [],
      CitiesData: [],
      disStatesData: [],
      disCitiesData: [],
      defaultadd: true,
      defaultdisadd: true,
      dnrequired: false,
      fifoprice: "",
      lifoprice: "",
      avgprice: "",
      insurancereq: false,
      insurance: 0,
      tcsableamount: 0,
      insuranceamount: 0,
      ccinsuranceamount: 0,
      insurancetax: 0,
      einvoice: false,
      additionalchargeslist: [],
      additionalcharges: 0,
      additionalchargestax: 0,
      totaladditionalcharges: 0,
      cctotaladditionalcharges: 0,
      additionalchargestaxamount: 0,
      natureofcharge: "",
      invoiceadditionalcharges: 0,
      ccinvoiceadditionalcharges: 0,
      invoiceadditionalchargestax: 0,
      ccinvoiceadditionalchargestax: 0,
      totalinsuranceamount: 0,
      cctotalinsuranceamount: 0,
      samedaydelivery: einvoice ? false : true,
      totalinvoice: 0,
      addtype: "Dispatch details",
      errormsg: [],
      transportername: null,
      deliverymethods: [
        { value: "1", name: "Own Vehicle" },
        { value: "2", name: "Hired Vehicle" },
        { value: "3", name: "GTA" },
        { value: "4", name: "Others" },
      ],
      transmode: 1,
      vehicletypes: [
        { value: "O", name: "ODC" },
        { value: "R", name: "Regular" },
      ],
      vehicletype: "R",
      supplytype: "O",
      transportationmode: 1,
      transactiontype: 1,
      dlryaccordian: true,
      addchraccordian: true,
      itemstock: 0,
      iscomposite: false,
      transporterslist: [],
      transporterselectiontype: false,
      validtrnsid: einvoice ? false : true,
      additionalChargesEnabled: true,
      insuranceEnabled: false,
      tcsEnabled: false,
      isTCSMode: true,
      addressType: 'dispatch',

      WarehouseList: [],
      DepartmentList: [],
      CategoryList: [],
      ServiceCategoryList: [],
      itemList: [],
      filteritemlist: [],
      sizelist: [],
      whdata: [],
      warehouse: "",
      whid: "",
      department: "",
      deptid: "",
      itemname: "",
      hsnid: "",
      hsn: "",
      price: "",
      ccprice: "",
      type: "",
      uom: null,
      category: "",
      categoryid: "",
      uomid: "",
      description: "",
      brand: "",
      model: "",
      size: "",
      colour: "",
      thickness: "",
      totalmtrroll: "",
      settings: "",
      discounttype: "%",
      discount: "",
      discountamount: "",
      ccdiscountamount: "",
      pricevariance: 0,
      taxtype: taxtype,
      gsttype: "INTRASTATE",
      taxtypelist: ["GST", "VAT"],
      gsttypelist: ["INTRASTATE", "INTERSTATE", "UT"],
      taxrequired: true,
      convertionreq: false,
      basecurrency: "",
      tax: 0,
      sgst: 0,
      cgst: 0,
      serviceitemList: [],
      service: "",
      serviceid: "",
      servicecategory: "",
      servicecatid: "",
      servicecode: "",
      servicetax: "",
      servicecost: "",
      servicecostconv: 0,
      servicecgst: "",
      servicesgst: "",
      serviceigst: "",
      servicegst: "",
      servicevat: "",
      servicetaxamount: "",
      servicecostwttaxconv: 0,
      servicecostwttax: "",
      servicedescription: "",
      servicetotal: "",
      serviceerr: "",
      grandservicetotal: 0,
      ccountrygrandservicetotal: 0,
      servicedata: [],
      transidreq: false,
      autojre: false,
      valueroundoff: 0,
      markup1: 0,
      markup: 0,
      invoiceremarks: "",
      customcreatedAt: "",
      SDdate: false,
      multiCurrency: false,
      duedate: new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
      totalpricewtax: 0,
      cctotalpricewtax: 0,
      // --- NEW computed totals (will be set by recomputeTotals) ---
      subtotal: 0,
      ccsubtotal: 0,
      taxTotal: 0,
      cctaxTotal: 0,
      additionalChargesTotal: 0,
      ccadditionalChargesTotal: 0,
      insuranceTotal: 0,
      ccinsuranceTotal: 0,
      tcsTotal: 0,
      cctcsTotal: 0,
      tdsTotal: 0,
      cctdsTotal: 0,
      invNumber: 0,
      finacialLatestInvoiceNumber: null,
      recurring: false,
      recurringenddate: "",
      recurringperiod: "Daily",
      recurringconfirm: "Manual"
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleServicecategory = (value, values) => {
    if (values !== "" && values !== undefined && typeof values === "object") {
      this.setState({
        servicecatid: values.id,
        servicecategory: values.category,
        filterserv: this.state.serviceitemList.filter(
          (e) => e.catid === values.id
        ),
        servicecost: "",
        servicecostwttax: "",
        servicetaxamount: "",
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    } else {
      this.setState({
        servicecatid: "",
        servicecategory: "",
        filterserv: [],
        servicecost: "",
        servicecostwttax: "",
        servicetaxamount: "",
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    }
  };

  handleService = (value, values) => {
    if (values !== "" && values !== undefined && typeof values === "object") {
      this.setState({
        serviceid: values.id,
        service: values.service,
        servicetax: this.state.taxrequired === true ? values.servicetax : 0,
        servicecode: values.servicecode,
        servicedescription: values.description,
        servicecatid: values.servicecatid,
        servicecategory: values.servicecategory,
        servicecost: "",
        servicecostwttax: "",
        servicetaxamount: "",
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    } else {
      this.setState({
        serviceid: "",
        service: "",
        servicetax: 0,
        servicecode: "",
        servicedescription: "",
        servicecost: "",
        servicecostwttax: "",
        servicetaxamount: "",
        servicecatid: "",
        servicecategory: "",
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    }
  };

  handleServiceAmountChange = (value, quantity) => {
    let val = parseFloat(value) * (quantity && quantity !== 0 ? parseFloat(quantity) : 1)
    this.setState({
      servicecost: value,
      servicecostconv:
        val * this.state.curconversionrate,
      servicetaxamount:
        (this.state.servicetax / 100) * val,
      servicecgst:
        ((this.state.servicetax / 100) * val) / 2,
      servicesgst:
        ((this.state.servicetax / 100) * val) / 2,
      serviceigst: (this.state.servicetax / 100) * val,
      servicegst: (this.state.servicetax / 100) * val,
      servicevat: (this.state.servicetax / 100) * val,
      servicecostwttax:
        val +
        (this.state.servicetax / 100) * val,
      servicecostwttaxconv:
        (val +
          (this.state.servicetax / 100) * val) *
        this.state.curconversionrate,
    });
  };

  handleaddService = () => {
    let servicedata = {
      serviceid: this.state.serviceid,
      service: this.state.service,
      servicedescription: this.state.servicedescription,
      servicetax: this.state.servicetax,
      servicecost: this.state.servicecost,
      servicecode: this.state.servicecode,
      servicetaxamount: this.state.servicetaxamount,
      servicecgst: this.state.servicecgst,
      servicesgst: this.state.servicesgst,
      serviceigst: this.state.serviceigst,
      servicegst: this.state.servicegst,
      servicevat: this.state.servicevat,
      quantity: parseFloat(this.state.quantity),
      servicetotal: this.state.servicecostwttax,
      servicecompleted: 0,
      recurrencetill: this.state.recurrencetill,
    };
    this.state.serviceList.push(servicedata);

    this.setState({
      serviceList: [...this.state.serviceList],
      grandservicetotal: this.state.grandservicetotal + this.state.servicecostwttax,
    });
  };

  handleCustomer = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      SalesServices.GetCustomerTerms(values.id).then((res) =>
        SalesServices.IsPaymentPending(values.id).then((response) => {
          if (
            response.data &&
            res.data !== null &&
            res.data.creditstatus === "Required"
          ) {
            Swal.fire({
              title: 'Pending payment from customer!',
              text: "Payment is due from the customer, please settle it before continuing",
              icon: "warning",
              confirmButtonColor: "#152f5f",
            }).then(() =>
              this.setState({
                custid: "",
                customer: "",
                saleorderid: "",
                customerdetails: "",
                saleorderdata: [],
                accepteditems: [],
                tcsableamount: 0,
                totaladditionalcharges: 0,
                cctotaladditionalcharges: 0,
                invoiceadditionalcharges: 0,
                invoiceadditionalchargestax: 0,
                ccinvoiceadditionalcharges: 0,
                ccinvoiceadditionalchargestax: 0,
              }))

          } else {
            this.setState({
              custid: values.id,
              customer: values.companyname,
              debitamount: values.debitamount,
              openingbalance: values.openingbalance,
              adjustopen: false,
              adjustdebit: values.debitamount > 0 ? true : false,
              einvoice:
                this.state.einvoice && values.countryname === "India"
                  ? true
                  : false,
              saleorderid: "",
              tcsableamount: 0,
              totaladditionalcharges: 0,
              invoiceadditionalcharges: 0,
              invoiceadditionalchargestax: 0,
              cctotaladditionalcharges: 0,
              ccinvoiceadditionalcharges: 0,
              ccinvoiceadditionalchargestax: 0,

              name: values.companyname,
              phoneno: values.contactnumber,
              pincode: values.zip,
              state: values.statename,
              city: values.cityname,
              houseno: values.address,
              areaname: values.address2,
              country: values.countryname,
              statecode: values.statecode,
              currency: values.currency,
              currencyid: this.state.currencylist.find(
                (e) => e.currency === values.currency
              ).id,
              taxtype: values.taxtype,
              gsttype:
                values.statename === cstate && values.countryname === "India"
                  ? "INTRASTATE"
                  : "INTERSTATE",
              convertionreq:
                values.currency === this.state.basecurrency ? false : true,
            }, () => this.recomputeTotals());

            const id = values.id;
            datalist = [];

            let selectedcustomer = this.state.custom.filter(
              (customer) => customer.id === id
            );
            this.setState({ customerdetails: selectedcustomer });

            let datadao = {
              tenantid: currentTenant,
              startdate: financialyearstart,
              enddate: financialyearend,
              userid: userid,
              dataaccess: dataaccess,
              whid: userwhid,
              id: id,
              poupload: this.state.pouploadm === "YES" ? true : false,
            };

            if (this.state.settings.salesautojre === "YES") {
              if (values.ledgerid === null || values.ledgerid === "" || values.ledgerid === undefined) {
                Swal.fire({
                  title: '',
                  text: "As ledger is not created for the customer journal entry cannot be auto inserted, please do the manual entry.",
                  icon: "warning",
                  confirmButtonColor: "#152f5f",
                }).then(() => this.setState({ autojre: false }))
              } else {
                this.setState({ autojre: true })
              }
            } else {
              this.setState({ autojre: false })
            }

            MasterService.getDistance(this.state.dispincode, values.zip).then(
              (res) => this.setState({ distance: res.data === '' || res.data === null || res.data === undefined ? 0 : res.data })
            );
          }
        })
      );

    } else {
      this.setState({
        custid: "",
        customer: "",
        saleorderid: "",
        customerdetails: "",
        saleorderdata: [],
        accepteditems: [],
        tcsableamount: 0,
        totaladditionalcharges: 0,
        invoiceadditionalcharges: 0,
        invoiceadditionalchargestax: 0,
        cctotaladditionalcharges: 0,
        ccinvoiceadditionalcharges: 0,
        ccinvoiceadditionalchargestax: 0,
      });
    }
  };

  handleWarehouse = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        warehouse: values.name,
        whid: values.id,
        deptid: "",
        department: "",
        itemname: "",
        hsnid: "",
        hsn: "",
        quantity: "",
        price: "",
        type: "",
        uom: "",
        uomid: "",
        description: "",
      });
      DepartmentServices.deptbywarehouse(values.id).then((response) => {
        this.setState({
          DepartmentList: response.data
        })
        if (response.data.length === 1) {
          this.setState({
            department: response.data[0].name,
            deptid: response.data[0].id
          })
        }
      });
    } else {
      this.setState({ warehouse: "", whid: "" });
    }
  };

  handleDepartment = (value, values) => {
    if (values !== "" && typeof values === 'object' && values !== null) {
      this.setState({
        department: values.name,
        deptid: values.id
      })
    } else {
      this.setState({ department: '', deptid: '' })
    }

  }

  handleCategory = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        categoryid: values.id,
        category: values.category,
        filteritemlist: this.state.itemList.filter(
          (e) => e.catid === values.id
        ),
        itemid: "",
        itemname: "",
        hsn: "",
        tax: "",
        price: "",
        quantity: "",
      });
    } else {
      this.setState({
        categoryid: "",
        category: "",
        filteritemlist: [],
        itemid: "",
        itemname: "",
        hsn: "",
        tax: "",
        price: "",
        quantity: "",
      });
    }
  };

  handleitem = (value, values) => {
    if (this.state.whid === "" || this.state.warehouse === "") {
      alert("Please Select Org Unit");
    } else {
      if (values !== "" && typeof values === "object" && values !== null) {
        this.setState({
          itemid: values.itemid,
          itemname: values.name,
          quantity: "",
          totalpricewtax: "",
        });
        // if (this.state.creditstatus !== "NotRequired") {
        //   if (this.state.availabelcredit < 0) {
        //     this.setState({ availabelcredit: this.state.creditvalue });
        //   }
        // }
        const id = values.itemid;
        // SalesServices.getprice(id).then((res) =>
        let itemdata = this.state.itemList.filter((e) => e.itemid === id);
        itemdata.map((data) =>
          this.setState({
            type:
              this.state.salescalreq === "YES"
                ? "LIFO"
                : data.type === null || data.type === undefined
                  ? "LIFO"
                  : data.type,
            price: data.price,
            markup1: data.markup1,
            markup: data.markup,
            hsn: data.hsn,
            uom: data.uom,
            uomid: data.uomid,
            brand: data.brand,
            model: data.model,
            tax: this.state.taxrequired === true ? data.tax : 0,
            cgst: this.state.taxrequired === true ? data.tax / 2 : 0,
            sgst: this.state.taxrequired === true ? data.tax / 2 : 0,
            additionalparams: data.additionalparams,
            description: data.description,
          })
        );
        let warehousedata = this.state.whdata.filter(
          (e) => e.whid === this.state.whid
        );
        let saleslist = warehousedata.find((e) => e).saleslist;
        let a = saleslist.filter((e) => e.itemid === id);
        // let stock = a.map(e => e.currentstock)[0] === undefined ? 0 : a.map(e => e.currentstock)
        let stock = a.reduce(
          (total, currentValue) => (total = total + currentValue.currentstock),
          0
        );
        this.setState({ stock: stock });
      } else {
        this.setState({ itemname: "", itemid: "" });
      }
    }
  };

  handleTypeChange = (e) => {
    this.setState({ type: e.target.value });
  };

  handleSelectDiscountType = (e) => {
    this.setState({ discounttype: e.target.value, discount: 0, discountamount: 0 });
  }

  handleDiscountChange = (e) => {
    if (this.state.discounttype === "%") {
      this.setState({ discount: e.target.value, discountamount: 0 })
    } else {
      this.setState({ discount: 0, discountamount: e.target.value })
    }
  }


  handlemarkup1Change = (e) => {
    this.setState({
      markup1: e.target.value,
    })
  }


  handleSize = (value, values) => {
    if (
      value !== "" &&
      this.state.sizelist.includes(values) &&
      values !== null
    ) {
      this.setState({ size: values });
    } else {
      this.setState({ size: "" });
    }
  };

  handleColour = (value, values) => {
    if (
      values !== "" &&
      this.state.colourlist.includes(values) &&
      values !== null
    ) {
      this.setState({ colour: values });
    } else {
      this.setState({ colour: "" });
    }
  };

  handlemilestonestatus = (i) => {
    this.state.milestones.find((e, index) => index === i).servicestatus =
      "Completed";
    this.setState({
      completed: this.state.milestones.find((e, index) => index === i),
    });
  };

  handleSaleOrder = (value, values) => {
    if (
      values !== "" &&
      this.state.saleorderdata.includes(values) &&
      values !== null
    ) {
      this.setState({
        saleorderid: values,
        tcsableamount: 0,
        totaladditionalcharges: 0,
        invoiceadditionalcharges: 0,
        invoiceadditionalchargestax: 0,
        cctotaladditionalcharges: 0,
        ccinvoiceadditionalcharges: 0,
        ccinvoiceadditionalchargestax: 0,
      });
      const id = values;
      datalist = [];

      SalesServices.GetDataforInvoice(id).then((response) =>
        this.setState({
          sodata: response.data,
          agent: response.data.agent,
          agentid: response.data.agentid,
          whid: response.data.whid,
          deptid: response.data.deptid,
          currency: response.data.currency,
          curconversionrate: response.data.curconversionrate,
          gsttype: response.data.gsttype,
          taxtype: response.data.taxtype,
          // saleorderitems: response.data.saleorderitems,
          serviceList: response.data.servicelist,
          saleorderitems: response.data.saleorderitems,
          serviceid:
            response.data.sotype === 1
              ? response.data.servicelist.find((e) => e).serviceid
              : "",
          milestones:
            response.data.sotype === 1
              ? response.data.servicelist.find((e) => e).milestones
              : [],
          contracttype:
            response.data.sotype === 1
              ? response.data.servicelist.find((e) => e).contracttype
              : "",
          totaltaxamount: response.data.totaltaxamount,
          totaliv: response.data.totaliv,
          grandtotal: response.data.grandtotalproducttotal,
          grandservicetotal: response.data.grandservicetotal,
          sotype: response.data.sotype,
          creditperiod:
            response.data.creditperiod === null ||
              response.data.creditperiod === undefined
              ? 0
              : response.data.creditperiod,
          accepteditems:
            this.state.pagename === "New Proforma Invoice" ||
              response.data.sotype === 2
              ? response.data.saleorderitems
              : [],
          completed:
            response.data.sotype === 1 &&
              this.state.pagename === "New Proforma Invoice"
              ? response.data.servicelist.find((e) => e).milestones[0]
              : "",
          addservice: response.data.sotype === 2 ? true : false,
          pricevariance: response.data.pricevariance,
        })
      );
    } else {
      this.setState({
        saleorderid: "",
        DnIDList: [],
        accepteditems: [],
        sodata: "",
        serviceList: [],
        saleorderitems: [],
        serviceid: "",
        milestones: [],
        contracttype: "",
        totaltaxamount: 0,
        totaliv: 0,
        grandtotal: 0,
        grandservicetotal: 0,
        sotype: 0,
        tcsableamount: 0,
        totaladditionalcharges: 0,
        invoiceadditionalcharges: 0,
        invoiceadditionalchargestax: 0,
        cctotaladditionalcharges: 0,
        ccinvoiceadditionalcharges: 0,
        ccinvoiceadditionalchargestax: 0,
      });
    }
  };

  TransporteridChange = (e) => {
    this.setState({ transporterid: e.target.value?.trim().toUpperCase() });
    if (this.state.einvoice) {
      if (e.target.value.length === 15) {
        let data = {
          tenantId: currentTenant,
          reqparam: e.target.value.trim().toUpperCase(),
        };
        SalesServices.validateGSTIN(data)
          .then((response) => {
            if (
              response.data.body === null ||
              response.data.body.statusCodeValue === 400
            ) {
              this.setState({ err: true, validtrnsid: false });
              Swal.fire({
                title: `Invalid Transporter ID`,
                text: ".",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              });
            } else {
              this.setState({ validtrnsid: true, err: false });
            }
          })
          .catch(() => this.setState({ err: true, validtrnsid: false }));
      } else {
        this.setState({
          err: false,
          validtrnsid: false,
        });
      }
    } else {
      this.setState({
        transporterid: e.target.value,
        err: false,
        validtrnsid: true,
      });
    }
  };

  handleinsurancereq = (e) => {
    this.setState({ insurancereq: !this.state.insurancereq });
  };

  handleInsuranceChange = (e) => {
    this.setState({
      insurance: e.target.value === "" ? 0 : parseFloat(e.target.value),
      insuranceamount:
        ((this.state.totalinvoice * parseFloat(e.target.value)) / 100).toFixed(
          3
        ) === "NaN"
          ? 0
          : (
            (this.state.totalinvoice * parseFloat(e.target.value)) /
            100
          ).toFixed(2),
      totalinsuranceamount:
        e.target.value === ""
          ? 0
          : (
            parseFloat(
              (this.state.totalinvoice * parseFloat(e.target.value)) / 100
            ) +
            (parseFloat(
              (this.state.totalinvoice * parseFloat(e.target.value)) / 100
            ) *
              parseFloat(this.state.insurancetax)) /
            100
          ).toFixed(2),
    });
  };

  handleInsuranceAmount = (e) => {
    this.setState({
      insuranceamount: e.target.value === "" ? 0 : parseFloat(e.target.value),
      insurance:
        e.target.value === ""
          ? 0
          : (parseFloat(e.target.value) / this.state.totalinvoice) * 100,
      totalinsuranceamount:
        e.target.value === ""
          ? 0
          : (
            parseFloat(e.target.value) +
            (parseFloat(e.target.value) *
              parseFloat(this.state.insurancetax)) /
            100
          ).toFixed(3),
    });
  };

  handleInsuranceTax = (e) => {
    const iamt = parseFloat(this.state.insuranceamount)
    const currval = parseFloat(e.target.value)
    const taxindec = ((currval / 100) * iamt).toFixed(2)
    console.log(iamt, taxindec)
    this.setState({
      insurancetax: parseFloat(e.target.value),
      totalinsuranceamount: (parseFloat(iamt) + parseFloat(taxindec)),
    });
  };

  handleDefaultadd = () => {
    const nextValue = !this.state.defaultadd;
    let update = { defaultadd: nextValue };
    if (nextValue) {
      let data = this.state.custom.find((e) => e.id === this.state.custid);
      if (data) {
        Object.assign(update, {
          name: data.companyname,
          phoneno: data.contactnumber,
          pincode: data.zip,
          state: data.statename,
          city: data.cityname,
          houseno: data.address,
          areaname: data.address2,
          country: data.countryname,
          statecode: data.statecode,
        });
      }
    } else {
      Object.assign(update, {
        name: "",
        phoneno: "",
        pincode: "",
        state: "",
        city: "",
        houseno: "",
        areaname: "",
        country: "",
        statecode: "",
      });
    }
    this.setState(update);
  };

  handleDefaultdisadd = () => {
    const nextValue = !this.state.defaultdisadd;
    let update = { defaultdisadd: nextValue };
    if (nextValue) {
      Object.assign(update, {
        disname: clientname || "",
        disphoneno: contactnumber || "",
        dispincode: czip || "",
        disstate: cstate || "",
        disstatecode: cstatecode || "",
        discity: ccity || "",
        dishouseno: address || "",
        disareaname: address2 || "",
        discountry: ccountry || "",
      });
    } else {
      Object.assign(update, {
        disname: "",
        disphoneno: "",
        dispincode: "",
        disstate: "",
        discity: "",
        dishouseno: "",
        disareaname: "",
        discountry: "",
        disstatecode: "",
      });
    }
    this.setState(update);
  };
  handleMultiCurrencyToggle = (checked) => {
    this.setState({ multiCurrency: checked });
    if (!checked) {
      this.setState({
        currency: this.state.basecurrency,
        currencyid: this.state.currencylist.find(e => e.currency === this.state.basecurrency)?.id,
        curconversionrate: 1,
      }, () => this.recomputeTotals());
    } else {
      this.recomputeTotals();
    }
  }

  handleDNreq = () => {
    this.setState({
      dnrequired: !this.state.dnrequired,
    });
  };

  handleCountryChange = (e, newValue) => {
    if (newValue === "" || newValue === null || newValue === undefined) {
    } else {
      this.setState({
        country: newValue.name,
        StatesData: newValue.states,
        err: false,
      });
    }
  };

  handleStateChange = (e, newValue) => {
    if (newValue === "" || newValue === null || newValue === undefined) {
    } else {
      this.setState({
        state: newValue.name,
        statecode: newValue.code,
        CitiesData: newValue.cities,
        err: false,
      });
    }
  };
  handleCityChange = (e, newValue) => {
    if (newValue === "" || newValue === null || newValue === undefined) {
    } else {
      this.setState({ city: newValue.name, err: false });
    }
  };

  handleDisCountryChange = (e, newValue) => {
    if (newValue === "" || newValue === null || newValue === undefined) {
    } else {
      this.setState({
        discountry: newValue.name,
        disStatesData: newValue.states,
        err: false,
      });
    }
  };

  handleDisStateChange = (e, newValue) => {
    if (newValue === "" || newValue === null || newValue === undefined) {
    } else {
      this.setState({
        disstate: newValue.name,
        disstatecode: newValue.code,
        disCitiesData: newValue.cities,
        err: false,
      });
    }
  };
  handleDisCityChange = (e, newValue) => {
    if (newValue === "" || newValue === null || newValue === undefined) {
    } else {
      this.setState({ discity: newValue.name, err: false });
    }
  };

  handletcsreq = (e) => {
    this.setState({ tcsreq: !this.state.tcsreq });
  };
  handletcsChange = (e) => {
    const newVal = parseFloat(e.target.value) || 0;
    this.setState({
      tcs: newVal
    }, () => this.recomputeTotals());
  };

  recomputeTotals = () => {
    const {
      accepteditems,
      serviceList,
      additionalchargeslist,
      curconversionrate,
      insuranceEnabled,
      insurance,
      insurancetax,
      tcsEnabled,
      isTCSMode,
      tcs,
      tds,
      taxrequired,
      taxtype,
      gsttype,
      currency,
      basecurrency,
    } = this.state;

    const isMultiCurrency = currency !== basecurrency;

    // Helper to compute one item's totals in invoice currency and base currency
    const computeItem = (item) => {
      let priceInv, priceBase, markupInv, markupBase;
      if (isMultiCurrency) {
        // Multi‑currency: ccprice / ccmarkup1 are invoice values
        priceInv = item.ccprice || 0;
        priceBase = item.price || (priceInv / (curconversionrate || 1));
        markupInv = item.ccmarkup1 || 0;
        markupBase = item.markup1 || (markupInv / (curconversionrate || 1));
      } else {
        // Single currency: price / markup1 are invoice values
        priceInv = item.price || 0;
        priceBase = item.ccprice || priceInv;
        markupInv = item.markup1 || 0;
        markupBase = item.ccmarkup1 || markupInv;
      }

      let qty = item.quantity || 0;
      let discountPct = item.discount || 0;
      let taxPct = item.tax || 0;
      let priceVariance = item.pricevariance || 0;

      let effectivePriceInv = (priceInv) * (1 + priceVariance / 100);
      let effectivePriceBase = (priceBase) * (1 + priceVariance / 100);

      let baseInv = effectivePriceInv * qty;
      let baseBase = effectivePriceBase * qty;

      let discountInv = baseInv * (discountPct / 100);
      let discountBase = baseBase * (discountPct / 100);

      let afterDiscountInv = baseInv - discountInv;
      let afterDiscountBase = baseBase - discountBase;

      let taxInv = 0, taxBase = 0;
      if (taxrequired && taxPct) {
        if (taxtype === "GST" && ccountry === "India" && gsttype === "INTRASTATE") {
          taxInv = afterDiscountInv * (taxPct / 100);
          taxBase = afterDiscountBase * (taxPct / 100);
        } else {
          taxInv = afterDiscountInv * (taxPct / 100);
          taxBase = afterDiscountBase * (taxPct / 100);
        }
      }

      return {
        baseInv: afterDiscountInv,
        baseBase: afterDiscountBase,
        taxInv,
        taxBase,
        totalInv: afterDiscountInv + taxInv,
        totalBase: afterDiscountBase + taxBase,
        discountInv,
        discountBase,
      };
    };

    // Helper for services (already correct – ccservicecost = invoice, servicecost = base)
    const computeService = (svc) => {
      let costInv = svc.ccservicecost || 0;
      let costBase = svc.servicecost || (costInv * curconversionrate);
      let markupInv = svc.ccmarkup1 || 0;
      let markupBase = svc.markup1 || (markupInv * curconversionrate);
      let qty = svc.quantity || 1;
      let discountPct = svc.servicediscount || 0;
      let taxPct = svc.servicetax || 0;

      let baseInv = (costInv + markupInv) * qty;
      let baseBase = (costBase + markupBase) * qty;

      let discountInv = baseInv * (discountPct / 100);
      let discountBase = baseBase * (discountPct / 100);

      let afterDiscountInv = baseInv - discountInv;
      let afterDiscountBase = baseBase - discountBase;

      let taxInv = 0, taxBase = 0;
      if (taxrequired && taxPct) {
        if (taxtype === "GST" && ccountry === "India" && gsttype === "INTRASTATE") {
          taxInv = afterDiscountInv * (taxPct / 100);
          taxBase = afterDiscountBase * (taxPct / 100);
        } else {
          taxInv = afterDiscountInv * (taxPct / 100);
          taxBase = afterDiscountBase * (taxPct / 100);
        }
      }

      return {
        baseInv: afterDiscountInv,
        baseBase: afterDiscountBase,
        taxInv,
        taxBase,
        totalInv: afterDiscountInv + taxInv,
        totalBase: afterDiscountBase + taxBase,
        discountInv,
        discountBase,
      };
    };

    // Sum products
    let itemsTotalInv = 0, itemsTotalBase = 0;
    let subtotalInv = 0, subtotalBase = 0;
    let taxTotalInv = 0, taxTotalBase = 0;
    let discountTotalInv = 0, discountTotalBase = 0;
    accepteditems.forEach(item => {
      const res = computeItem(item);
      itemsTotalInv += res.totalInv;
      itemsTotalBase += res.totalBase;
      subtotalInv += res.baseInv;
      subtotalBase += res.baseBase;
      taxTotalInv += res.taxInv;
      taxTotalBase += res.taxBase;
      discountTotalInv += res.discountInv;
      discountTotalBase += res.discountBase;
    });

    // Sum services
    let servicesTotalInv = 0, servicesTotalBase = 0;
    if (this.state.milestones.length === 0) {
      if (this.state.invtype === "Order Invoice") {
        serviceList.filter(e => e.status).forEach(svc => {
          const res = computeService(svc);
          servicesTotalInv += res.totalInv;
          servicesTotalBase += res.totalBase;
          subtotalInv += res.baseInv;
          subtotalBase += res.baseBase;
          taxTotalInv += res.taxInv;
          taxTotalBase += res.taxBase;
          discountTotalInv += res.discountInv;
          discountTotalBase += res.discountBase;
        });
      } else {
        serviceList.forEach(svc => {
          const res = computeService(svc);
          servicesTotalInv += res.totalInv;
          servicesTotalBase += res.totalBase;
          subtotalInv += res.baseInv;
          subtotalBase += res.baseBase;
          taxTotalInv += res.taxInv;
          taxTotalBase += res.taxBase;
          discountTotalInv += res.discountInv;
          discountTotalBase += res.discountBase;
        });
      }
    } else {
      //  const res = computeService(svc);
      servicesTotalInv += this.state.completed.cctotalprice;
      servicesTotalBase += this.state.completed.totalprice;
      subtotalInv += this.state.completed.cctotalprice;
      subtotalBase += this.state.completed.totalprice;
      taxTotalInv += this.state.completed.cctaxamount;
      taxTotalBase += this.state.completed.taxamount;
      discountTotalInv += this.state.completed.ccdiscountInv;
      discountTotalBase += this.state.completed.discountBase;
    }

    // Additional charges (unchanged)
    let additionalChargesTotalInv = 0, additionalChargesTotalBase = 0;
    additionalchargeslist.forEach(charge => {
      let amtInv = charge.ccadditionalcharges || 0;
      let amtBase = charge.additionalcharges || (amtInv * curconversionrate);
      let taxPct = charge.additionalchargestax || 0;
      let totalInv = amtInv * (1 + taxPct / 100);
      let totalBase = amtBase * (1 + taxPct / 100);
      additionalChargesTotalInv += totalInv;
      additionalChargesTotalBase += totalBase;
    });

    // Insurance (unchanged)
    let insuranceTotalInv = 0, insuranceAmtInv = 0, insuranceTotalBase = 0;
    if (insuranceEnabled) {
      let baseForInsuranceInv = subtotalInv;
      let baseForInsuranceBase = subtotalBase;
      insuranceAmtInv = baseForInsuranceInv * (insurance / 100);
      let insuranceAmtBase = baseForInsuranceBase * (insurance / 100);
      let insuranceTaxInv = insuranceAmtInv * (insurancetax / 100);
      let insuranceTaxBase = insuranceAmtBase * (insurancetax / 100);
      insuranceTotalInv = insuranceAmtInv + insuranceTaxInv;
      insuranceTotalBase = insuranceAmtBase + insuranceTaxBase;
    }

    console.log(insuranceEnabled, insuranceTotalInv, insuranceAmtInv, insuranceTotalBase, subtotalInv, subtotalBase)

    // TCS / TDS (unchanged)
    let tcsTotalInv = 0, tcsTotalBase = 0;
    let tdsTotalInv = 0, tdsTotalBase = 0;
    if (tcsEnabled) {
      let baseForDeductionInv = subtotalInv + taxTotalInv + additionalChargesTotalInv + insuranceTotalInv;
      let baseForDeductionBase = subtotalBase + taxTotalBase + additionalChargesTotalBase + insuranceTotalBase;
      if (isTCSMode) {
        tcsTotalInv = baseForDeductionInv * (tcs / 100);
        tcsTotalBase = baseForDeductionBase * (tcs / 100);
      } else {
        tdsTotalInv = baseForDeductionInv * (tds / 100);
        tdsTotalBase = baseForDeductionBase * (tds / 100);
      }
    }

    // Grand total
    let grandTotalInv = subtotalInv + taxTotalInv + additionalChargesTotalInv + insuranceTotalInv + tcsTotalInv - tdsTotalInv;
    let grandTotalBase = subtotalBase + taxTotalBase + additionalChargesTotalBase + insuranceTotalBase + tcsTotalBase - tdsTotalBase;

    // Update state
    this.setState({
      subtotal: subtotalInv,
      ccsubtotal: subtotalBase,
      taxTotal: taxTotalInv,
      cctaxTotal: taxTotalBase,
      additionalChargesTotal: additionalChargesTotalInv,
      ccadditionalChargesTotal: additionalChargesTotalBase,
      insuranceamount: insuranceAmtInv,
      insuranceTotal: insuranceTotalInv,
      totalinsuranceamount: insuranceTotalInv,
      tcsTotal: tcsTotalInv,
      cctcsTotal: tcsTotalBase,
      tdsTotal: tdsTotalInv,
      cctdsTotal: tdsTotalBase,
      grandtotal: grandTotalInv,
      ccgrandtotal: grandTotalBase,
      totaltaxamount: taxTotalInv,
      cctotaltaxamount: taxTotalBase,
      totaldiscount: discountTotalInv,
      cctotaldiscount: discountTotalBase,
      totalinvoice: subtotalInv,
      cctotalinvoice: subtotalBase,
      invtotalamountwtax: grandTotalInv,
      ccinvtotalamountwtax: grandTotalBase,
      tcsableamount: grandTotalInv,
      grandservicetotal: servicesTotalInv,
      ccgrandservicetotal: servicesTotalBase,
      granditemstotal: itemsTotalInv,
      ccgranditemstotal: itemsTotalBase,
      totaliv: subtotalInv,
      cctotaliv: subtotalBase,
    });
  };


  handledownload = (file) => {
    downloadfiles.download(this.state.sodata.popath, this.state.sodata.pofile);
  };

  handleAccept = (id) => {

    let itemsdetails = this.state.saleorderitems.filter(
      (data) => data.id === id
    );
    this.setState({ quantity: "", description: "", show: 1 });
    itemsdetails.map((data) =>
      this.setState(
        {
          id: data.id,
          itemid: data.itemid,
          itemname: data.name,
          hsn: data.hsn,
          price: data.price,
          salesenum: "LIFO",
          tax: data.tax,
          categoryid: data.categoryid,
          taxamount: data.taxamount,
          markup: data.markup,
          markup1: data.markup1,
          orderedquantity: parseFloat(data.quantity),
          pendingquantity: parseFloat(data.pending),
          uom: data.uom,
          totalprice: data.totalprice,
          brand: data.brand,
          colour: data.colour,
          totalpricewtax: data.totalpricewtax,
          size: data.size,
          thickness: data.thickness,
          totalmtrroll: data.totalmtrroll,
          description: data.description,
          insurance: data.insurance,
          discount: data.discount,
          discountamount: data.discountamount,
          pricevariance: data.pricevariance,
          fifoprice: data.fifoprice,
          lifoprice: data.lifoprice,
          avgprice: data.avgprice,
          additionalchargestax: 0,
          additionalcharges: 0,
          totaladditionalcharges: 0,
          additionalchargestaxamount: 0,
          natureofcharge: "",
        },
        () =>
          this.setState({
            itemstock: this.state.whdata
              ?.find((e) => e.whid === this.state.sodata.whid)
              ?.saleslist?.find((e) => e.itemid === this.state.itemid)
              ?.totalstock,
            itemquantitylist: this.state.whdata
              .find((e) => e.whid === this.state.sodata.whid)
              .saleslist.filter(
                (sl) => sl.itemid === this.state.itemid && sl.currentstock !== 0
              )
              .map((e) => Object.assign(e, { enteredquantity: 0 })),
          })
      )
    );
  };

  AdditionalCharges = () => {
    if (
      this.state.additionalcharges === "" ||
      this.state.natureofcharge === ""
    ) {
      this.setState({ adderr: true });
    } else {
      let data = this.state.additionalchargeslist;
      data.push({
        additionalcharges: this.state.additionalcharges * this.state.curconversionrate,
        ccadditionalcharges: this.state.additionalcharges,
        additionalchargestax: this.state.additionalchargestax,
        additionalchargestaxamount: this.state.additionalchargestaxamount * this.state.curconversionrate,
        ccadditionalchargestaxamount: this.state.additionalchargestaxamount,
        totaladditionalcharges: parseFloat(this.state.totaladditionalcharges) * this.state.curconversionrate,
        cctotaladditionalcharges: parseFloat(this.state.totaladditionalcharges),
        natureofcharge: this.state.natureofcharge,
      });
      console.log(data)
      this.setState({
        additionalchargeslist: data,
        invoiceadditionalcharges: this.state.invoiceadditionalcharges + (parseFloat(this.state.totaladditionalcharges) * this.state.curconversionrate),
        invoiceadditionalchargestax: this.state.invoiceadditionalchargestax + (parseFloat(this.state.additionalchargestaxamount) * this.state.curconversionrate),
        ccinvoiceadditionalcharges: this.state.ccinvoiceadditionalcharges + (parseFloat(this.state.totaladditionalcharges)),
        ccinvoiceadditionalchargestax: this.state.ccinvoiceadditionalchargestax + (parseFloat(this.state.additionalchargestaxamount)),
        additionalcharges: 0,
        additionalchargestax: 0,
        additionalchargestaxamount: 0,
        totaladditionalcharges: 0,
        natureofcharge: "",
      }, () => this.recomputeTotals());

      if (this.state.autojre) {
        Swal.fire({
          title: '',
          text: "As you are adding additonal charges Auto journal entry is not possible, please do the manual entry.",
          icon: "warning",
          confirmButtonColor: "#152f5f",
        })
      }

    }
  };

  RemoveAdditionalCharges = (i) => {
    let data = this.state.additionalchargeslist.filter((e, idx) => idx !== i);
    let data2 = this.state.additionalchargeslist.find((e, idx) => idx === i);
    this.setState({
      additionalchargeslist: data,
      invoiceadditionalcharges:
        this.state.invoiceadditionalcharges - data2.totaladditionalcharges,
      invoiceadditionalchargestax:
        this.state.invoiceadditionalchargestax -
        data2.additionalchargestaxamount,
      additionalcharges: 0,
      additionalchargestax: 0,
      additionalchargestaxamount: 0,
      totaladditionalcharges: 0,
      natureofcharge: "",
    });
  };

  handleTransporterChange = (value, newValue) => {
    if (newValue === "" || newValue === null || newValue === undefined) {
      this.setState({
        transportername: "",
        transporterid: "",
        validtrnsid: false,
      });
    } else {
      this.setState({
        transportername: newValue.transname,
        transporterid: newValue.transid,
        validtrnsid: true,
      });
    }
  };

  onSubmit() {
    let ccprice = (parseFloat(this.state.price) + parseFloat(isInvalid.includes(this.state.markup1) ? 0 : this.state.markup1)) +
      ((parseFloat(this.state.price) + parseFloat(isInvalid.includes(this.state.markup1) ? 0 : this.state.markup1)) *
        parseFloat(isInvalid.includes(this.state.pricevariance) ? 0 : this.state.pricevariance)) / 100;

    let price = ccprice * parseFloat(isInvalid.includes(this.state.curconversionrate) ? 0 : this.state.curconversionrate)

    let ccd = (parseFloat(ccprice) * parseFloat(isInvalid.includes(this.state.discount) ? 0 : this.state.discount)) / 100;

    let d = ccd * parseFloat(isInvalid.includes(this.state.curconversionrate) ? 0 : this.state.curconversionrate)

    let halftaxroundoff = !this.state.taxrequired || this.state.taxrequired === "NA" ? 0 : ((parseFloat(this.state.tax / 2) * ((price - d) * parseFloat(this.state.quantity))) / 100).toFixed(2)

    let cchalftaxroundoff = !this.state.taxrequired || this.state.taxrequired === "NA" ? 0 : ((parseFloat(this.state.tax / 2) * ((ccprice - ccd) * parseFloat(this.state.quantity))) / 100).toFixed(2)

    let taxroundoff = !this.state.taxrequired || this.state.taxrequired === "NA" ? 0 : this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? (parseFloat(halftaxroundoff) + parseFloat(halftaxroundoff)) :
      ((parseFloat(this.state.tax) * ((price - d) * parseFloat(this.state.quantity))) / 100).toFixed(2)

    let cctaxroundoff = !this.state.taxrequired || this.state.taxrequired === "NA" ? 0 : this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? (parseFloat(cchalftaxroundoff) + parseFloat(cchalftaxroundoff)) :
      ((parseFloat(this.state.tax) * ((ccprice - ccd) * parseFloat(this.state.quantity))) / 100).toFixed(2)

    let totalpriceroundoff = ((price - d) * parseFloat(this.state.quantity)).toFixed(2)
    let cctotalpriceroundoff = ((ccprice - ccd) * parseFloat(this.state.quantity)).toFixed(2)

    let list = {
      id: this.state.id,
      soitemid: this.state.id,
      itemid: this.state.itemid,
      name: this.state.itemname,
      hsn: this.state.hsn,
      categoryid: this.state.categoryid,
      quantity: parseFloat(this.state.quantity),
      baseprice: parseFloat(this.state.price) * (isInvalid.includes(this.state.curconversionrate) ? 1 : this.state.curconversionrate),
      ccbaseprice: parseFloat(this.state.price),
      price: price,
      ccprice: ccprice,
      markup1: isInvalid.includes(this.state.markup1) ? 0 : this.state.markup1 * (isInvalid.includes(this.state.curconversionrate) ? 1 : this.state.curconversionrate),
      ccmarkup1: isInvalid.includes(this.state.markup1) ? 0 : this.state.markup1,
      markup: isInvalid.includes(this.state.markup) ? 0 : this.state.markup * (isInvalid.includes(this.state.curconversionrate) ? 1 : this.state.curconversionrate),
      ccmarkup: isInvalid.includes(this.state.markup) ? 0 : this.state.markup,
      salesenum: "LIFO",
      tax: !this.state.taxrequired || this.state.taxrequired === "NA" ? 0 : this.state.tax,
      discount: isInvalid.includes(this.state.discount) ? 0 : parseFloat(this.state.discount),
      discountamount: d * parseFloat(this.state.quantity),
      ccdiscountamount: ccd * parseFloat(this.state.quantity),
      taxamount: parseFloat(taxroundoff),
      cctaxamount: parseFloat(cctaxroundoff),
      description: this.state.description,
      totalprice: parseFloat(totalpriceroundoff),
      cctotalprice: parseFloat(cctotalpriceroundoff),
      pending: 0,
      uom: this.state.uom,
      brand: this.state.brand,
      colour: this.state.colour,
      totalpricewtax: parseFloat(totalpriceroundoff) + parseFloat(taxroundoff) + parseFloat(this.state.totaladditionalcharges || 0),
      cctotalpricewtax: parseFloat(cctotalpriceroundoff) + parseFloat(cctaxroundoff) + parseFloat(this.state.cctotaladditionalcharges || 0),
      size: this.state.size,
      thickness: this.state.thickness,
      totalmtrroll: this.state.totalmtrroll,
      pricevariance: this.state.pricevariance,
      fifoprice: this.state.fifoprice,
      lifoprice: this.state.lifoprice,
      avgprice: this.state.avgprice,
      additionalchargestax: this.state.additionalchargestax,
      additionalcharges: this.state.additionalcharges,
      totaladditionalcharges: this.state.totaladditionalcharges,
      additionalchargestaxamount: this.state.additionalchargestaxamount,
      natureofcharge: this.state.natureofcharge,
    };

    datalist.push(list);
    let checklist = datalist.filter(e => e.categoryid !== this.state.categoryid);

    if (this.state.autojre && checklist.length > 0) {
      Swal.fire({
        title: '',
        text: "As different ledger are added journal entry cannot be auto inserted, please do the manual entry.",
        icon: "warning",
        confirmButtonColor: "#152f5f",
      });
    }

    this.setState({
      accepteditems: datalist,
      autojre: this.state.autojre && checklist.length === 0 ? true : false,
      quantity: "",
      totalpricewtax: "",
      itemid: "",
      itemname: "",
      description: "",
      hsn: "",
      categoryid: "",
      price: "",
      tax: "",
      discount: "",
      markup: "",
      markup1: "",
    }, () => {
      this.recomputeTotals();
      if (
        datalist.length === 1 &&
        this.props.location.state.invid !== null &&
        this.props.location.state.invid !== undefined &&
        this.props.location.state.invid !== ""
      ) {
        MasterService.getDistance(this.state.dispincode, this.state.pincode).then((res) =>
          this.setState({ distance: res.data === null ? 0 : res.data })
        );
      }
    });
  }


  removeItemFromList = (index) => {
    let removed = this.state.accepteditems[index];
    datalist = this.state.accepteditems.filter((item, i) => i !== index);
    this.setState({
      accepteditems: datalist
    }, () => this.recomputeTotals());
  };

  editItemFromList = (index) => {
    let s = this.state.accepteditems[index];
    this.removeItemFromList(index);
    this.setState({
      itemid: s.itemid,
      itemname: s.name,
      description: s.description || "",
      hsn: s.hsn || "",
      categoryid: s.categoryid || "",
      quantity: s.quantity || "",
      price: s.ccbaseprice || s.ccprice || s.price || "",
      tax: s.tax || "",
      discount: s.discount || "",
      markup: s.ccmarkup || s.markup || "",
      markup1: s.ccmarkup1 || s.markup1 || "",
      uom: s.uom || "",
      brand: s.brand || "",
      size: s.size || "",
      colour: s.colour || "",
      thickness: s.thickness || "",
      totalmtrroll: s.totalmtrroll || "",
    });
  };

  clearCurrentItem = () => {
    this.setState({
      itemid: "",
      itemname: "",
      description: "",
      hsn: "",
      categoryid: "",
      quantity: "",
      price: "",
      tax: "",
      discount: "",
      markup: "",
      markup1: "",
      uom: "",
      brand: "",
      size: "",
      colour: "",
      thickness: "",
      totalmtrroll: "",
    });
  };

  handlesubmit = (values) => {
    if (this.state.customer === "") {
      Swal.fire({
        title: "Validation Error",
        text: "Please select a Customer.",
        icon: "error",
        confirmButtonColor: "#152f5f",
      });
      return;
    }

    if (this.state.accepteditems.length === 0) {
      Swal.fire({
        title: "Validation Error",
        text: "Please add at least one item or service.",
        icon: "error",
        confirmButtonColor: "#152f5f",
      });
      return;
    }
    if (
      (this.state.name === "" ||
        this.state.phoneno === "" ||
        this.state.pincode === "" ||
        this.state.pincode === undefined ||
        this.state.pincode === null ||
        this.state.state === "" ||
        this.state.city === "" ||
        this.state.houseno === "" ||
        this.state.houseno.length > 100 ||
        this.state.areaname === "" ||
        this.state.areaname.length > 100 ||
        this.state.country === "" ||
        this.state.disname === "" ||
        this.state.disphoneno === "" ||
        this.state.dispincode === "" ||
        this.state.dispincode === undefined ||
        this.state.dispincode === null ||
        this.state.disstate === "" ||
        this.state.discity === "" ||
        this.state.dishouseno === "" ||
        this.state.dishouseno.length > 100 ||
        this.state.disareaname === "" ||
        this.state.disareaname.length > 100 ||
        this.state.discountry === "" ||
        ((this.state.vehiclenum === "" ||
          this.state.distance === "" ||
          this.state.distance === null ||
          this.state.distance === undefined) &&
          // ||
          // this.state.transporterid === ""|| this.state.validtrnsid === false
          this.state.samedaydelivery)) &&
      this.state.pagename === "New Invoice"
    ) {
      this.setState({ err: true });
    } else {
      Swal.fire({
        title:
          this.state.pagename === "New Proforma Invoice"
            ? "Save & send Proforma Invoice for approvel?"
            : this.state.samedaydelivery && this.state.einvoice
              ? "Save & send Invoice for approvel along with Eway-bill details?"
              : "Save & send Invoice for approvel?",
        text: "Are you sure?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#152f5f",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.setState({ loader: true });
          let servicedata = [];
          if (this.state.invtype === "Direct Invoice") {
            if ((this.state.sotype === 1 || this.state.sotype === 2) && this.state.serviceList.length > 0) {
              this.state.serviceList.map((s) =>
                servicedata.push({
                  serviceid: s.serviceid,
                  service: s.service,
                  servicedescription: s.servicedescription,
                  servicetax: s.servicetax,
                  servicecost: parseFloat(s.servicecost),
                  servicecode: s.servicecode,
                  quantity: parseFloat(s.quantity),
                  servicetotal: parseFloat(s.servicetotal),
                  servicecatid: s.servicecatid,
                  servicecategory: s.servicecategory,
                })
              );
            }
          }
          let data = {
            saleorderid: this.state.saleorderid,
            // dnid:this.state.dnid,
            whid: this.state.whid,
            deptid: this.state.deptid,
            custid: this.state.custid,
            customer: this.state.customer,
            agent: isInvalid.includes(this.state.agentid) ? null : this.state.agentid,
            invid: this.state.invid,
            invtype: this.state.invtype,
            itemlist: this.state.accepteditems,
            milestone: this.state.completed === "" ? null : this.state.completed,
            serviceid: this.state.serviceid,
            createdby: userid,
            poid: this.state.poid,
            addservice: this.state.addservice ? true : this.state.sotype === 2 && servicedata.length > 0 ? true : false,
            creditperiod: this.state.creditperiod,
            currencyid: this.state.currencyid,
            currency: this.state.currency,
            services: servicedata,
            curconversionrate: parseFloat(this.state.curconversionrate),
            tcsreq: this.state.tcsreq,
            tenantid: currentTenant,
            tcs: this.state.tcs === undefined ? 0 : parseFloat(this.state.tcs),
            tcsamount: this.state.tcsamount === undefined ? 0 : parseFloat(this.state.tcsamount),
            tcsableamount: parseFloat(this.state.tcsableamount),
            name: this.state.name,
            phoneno: this.state.phoneno,
            pincode: this.state.pincode,
            state: this.state.state,
            statecode: this.state.statecode,
            city: this.state.city,
            houseno: this.state.houseno,
            areaname: this.state.areaname,
            country: this.state.country,
            adjustdebit: this.state.adjustdebit,
            adjustopen: this.state.adjustopen,
            disname: this.state.disname,
            disphoneno: this.state.disphoneno,
            dispincode: this.state.dispincode,
            disstate: this.state.disstate,
            disstatecode: this.state.disstatecode,
            discity: this.state.discity,
            dishouseno: this.state.dishouseno,
            disareaname: this.state.disareaname,
            discountry: this.state.discountry,
            iscomposite: this.state.iscomposite,
            invtype: "NonInventory",
            taxtype: this.state.taxrequired === false ? "NA" : this.state.taxtype,
            gsttype: this.state.gsttype,
            sotype: this.state.sotype,
            currency: this.state.currency,
            curconversionrate: this.state.curconversionrate,
            batnchidlist: this.state.batchidlist,
            insurancereq: this.state.insurancereq,
            insurance: this.state.insurancereq ? parseFloat(this.state.insurance) : 0,
            insuranceamount: this.state.insurancereq ? parseFloat(this.state.insuranceamount) * parseFloat(this.state.curconversionrate) : 0,
            ccinsuranceamount: this.state.insurancereq ? parseFloat(this.state.insuranceamount) : 0,
            insurancetax: this.state.insurancereq ? parseFloat(this.state.insurancetax) : 0,
            totalinsuranceamount: this.state.insurancereq ? parseFloat(this.state.totalinsuranceamount) * parseFloat(this.state.curconversionrate) : 0,
            cctotalinsuranceamount: this.state.insurancereq ? parseFloat(this.state.totalinsuranceamount) : 0,
            einvoicerequired: this.state.einvoice,
            additionalcharges: this.state.additionalchargeslist,
            totaladdtitionalcharges: parseFloat(this.state.invoiceadditionalcharges),
            cctotaladdtitionalcharges: parseFloat(this.state.ccinvoiceadditionalcharges),
            totaladdtitionalchargestax: parseFloat(this.state.invoiceadditionalchargestax),
            cctotaladdtitionalchargestax: parseFloat(this.state.ccinvoiceadditionalchargestax),
            samedaydelivery: this.state.samedaydelivery.toString(),
            vehiclenum: this.state.vehiclenum,
            transporterid: this.state.samedaydelivery ? this.state.transporterid : null,
            distance: isInvalid.includes(this.state.distance) || this.state.samedaydelivery === false ? 0 : parseInt(this.state.distance),
            transid: this.state.samedaydelivery ? this.state.transporterid : null,
            transname: this.state.samedaydelivery ? this.state.transname : null,
            vehicletype: this.state.vehicletype ? this.state.vehicletype : null,
            // Ttansmode:this.state.samedaydelivery?this.state.transmode:null,
            supplytype: this.state.samedaydelivery ? this.state.supplytype : null,
            transportationmode: this.state.samedaydelivery ? this.state.transportationmode : 0,
            transactiontype: this.state.samedaydelivery ? this.state.transactiontype : null,
            autojre: this.state.additionalchargeslist.length > 0 ? false : this.state.autojre,
            valueroundoff: this.state.valueroundoff,
            invoiceremarks: this.state.invoiceremarks,
            sddate: this.state.SDdate,
            date: this.state.SDdate ? this.state.customcreatedAt : null,
            duedate: this.state.duedate,
            recurring: this.state.recurring,
            recurringenddate: this.state.recurringenddate,
            recurringperiod: this.state.recurringperiod,
            recurringconfirm: this.state.recurringconfirm,
            invNumber: this.state.SDdate && this.state.finacialLatestInvoiceNumber === null ? this.state.invNumber === 0 ? 1 : this.state.invNumber : 0

          };
          if (this.state.pagename === "New Proforma Invoice") {
            SalesServices.GenerateProformaInvoice(data)
              .then((res) =>
                // this.props.navigate("/salesinvoice", {
                //   state: { message: "", type: "" },
                // })
                this.props.navigate("/viewsalesinvoice", {
                  state: { id: res.data, pagename: "Proforma Invoice Details", temp: false, type: "Proforma Invoice", goback: false },
                })
              )
              .catch((e) => {
                this.setState({ loader: false });
                if (e.response.data.error === "Unauthorized") {
                  alert("Your Session is Lost: Please login Back to resume");
                  this.props.navigate(`/`);
                }
              });
          } else {
            if (this.state.invid === -1) {
              SalesServices.GenerateInvoice(data)
                .then((res) =>
                  this.props.navigate("/viewsalesinvoice", {
                    state: { id: res.data, pagename: "Tax Invoice Details", temp: true, type: "Tax Invoice", goback: false },
                  })
                )
                .catch((e) => {
                  this.setState({
                    errormsg:
                      e.response.data.body === undefined
                        ? []
                        : JSON.parse(e.response.data.body),
                    loader: false,
                  });
                  if (
                    e.response === undefined ||
                    e.response.data.error === "Unauthorized"
                  ) {
                    alert("Your Session is Lost: Please login Back to resume");
                    this.props.navigate(`/`);
                  } else {
                    Swal.fire({
                      title:
                        e.response.data.body === undefined
                          ? e.response.data.error
                          : JSON.parse(e.response.data.body),
                      text: ".",
                      icon: "error",
                      confirmButtonText: "Ok",
                      confirmButtonColor: "#152f5f",
                    });
                  }
                });
            } else {
              SalesServices.UpdateInvoice(data)
                .then((res) =>
                  this.props.navigate("/viewsalesinvoice", {
                    state: { id: res.data, pagename: "Tax Invoice Details", temp: true, type: "Tax Invoice", goback: false },
                  })
                )
                .catch((e) => {
                  this.setState({
                    errormsg:
                      e.response.data.body === undefined
                        ? []
                        : JSON.parse(e.response.data.body),
                    loader: false,
                  });
                  if (
                    e.response === undefined ||
                    e.response.data.error === "Unauthorized"
                  ) {
                    alert("Your Session is Lost: Please login Back to resume");
                    this.props.navigate(`/`);
                  } else {
                    Swal.fire({
                      title:
                        e.response.data.body === undefined
                          ? "An unauthorized error occurred, Please try again after sometime"
                          : JSON.parse(e.response.data.body),
                      text: ".",
                      icon: "error",
                      confirmButtonText: "Ok",
                      confirmButtonColor: "#152f5f",
                    });
                  }
                });
            }
          }
        }
      });
    }
  };

  handleSelect = () => {
    // let a =this.state.itemquantitylist
    this.setState({ quantitywindow: true });
  };

  handleQuantityChange = (e, i) => {
    // this.setState({ quantity: e });

    let q;
    let data = this.state.itemquantitylist;
    if (e === "" || e === undefined || parseFloat(e) < 0) {
      q = 0;
    }
    // else if(this.state.pendingquantity<(parseFloat(e)+this.state.quantity)){
    //   q=this.state.pendingquantity-this.state.quantity
    // }
    else {
      q = parseFloat(e);
    }
    if (q > data.find((e, index) => index === i).currentstock) {
      data.find((e, index) => index === i).enteredquantity = data.find(
        (e, index) => index === i
      ).currentstock;
    } else {
      data.find((e, index) => index === i).enteredquantity = q;
    }
    let qa = data.reduce((a, b) => a + b.enteredquantity, 0);

    this.setState({ quantity: qa, itemquantitylist: data });
  };

  handleSaveQuantity = () => {
    if (this.state.pendingquantity < this.state.quantity) {
    } else {
      let data = this.state.itemquantitylist;
      let am = data.filter((a) => a.enteredquantity !== 0);
      if (this.state.batchidlist.length !== 0) {
        let bid = this.state.batchidlist.map((a) => a.batchid);
        am.map((a) =>
          bid.includes(a.batchid)
            ? (this.state.batchidlist.find(
              (b) => b.batchid === a.batchid
            ).quantity =
              this.state.batchidlist.find((b) => b.batchid === a.batchid)
                .quantity - a.enteredquantity)
            : this.state.batchidlist.push({
              batchid: a.batchid,
              quantity: a.enteredquantity,
              stockid: a.stockid,
              tenantid: currentTenant,
              whid: this.state.sodata.whid,
              itemid: this.state.itemid,
            })
        );
      } else {
        am.map((a) =>
          this.state.batchidlist.push({
            batchid: a.batchid,
            quantity: a.enteredquantity,
            stockid: a.stockid,
            tenantid: currentTenant,
            whid: this.state.sodata.whid,
            itemid: this.state.itemid,
          })
        );
      }
      this.setState({ quantitywindow: false, itemquantitylist: data });
    }
  };

  refreshData() {
    const id =
      this.props.location.state === undefined
        ? this.history.props.push("/saleorder")
        : this.props.location.state.id;

    if (id !== -1) {
      SalesServices.GetTempInvoice(id).then((res) => {
        this.setState({
          saleorderid: res.data.saleorderid,
          accepteditems: res.data.invoiceitemlist,
          completed: res.data.milestone,
          serviceid: res.data.serviceid,
          poid: res.data.poid,
          addservice: res.data.addservice,
          creditperiod: res.data.creditperiod,
          currencyid: res.data.currencyid,
          currency: res.data.currency,
          curconversionrate: parseFloat(res.data.curconversionrate),
          tcsreq: res.data.tcsreq,
          tcs: parseFloat(res.data.tcs),
          tcsamount: parseFloat(res.data.tcsamount),
          tcsableamount: parseFloat(res.data.tcsableamount),
          invtotalamountwtax: res.data.totalinvoicewtax,
          totalinvoice: res.data.totalinvoice,
          name: res.data.dname,
          taxtype: res.data.taxtype,
          gsttype: res.data.gsttype,
          phoneno: res.data.dphoneno,
          pincode: res.data.dpincode,
          state: res.data.dstate,
          statecode: res.data.dstatecode,
          city: res.data.dcity,
          houseno: res.data.dhouseno,
          areaname: res.data.dareaname,
          country: res.data.dcountry,
          adjustdebit: res.data.debitadjusted === null || res.data.debitadjusted === 0 ? false : true,
          adjustopen: res.data.openadjusted === null || res.data.openadjusted === 0 ? false : true,
          disname: res.data.disname,
          disphoneno: res.data.disphoneno,
          dispincode: res.data.dispincode,
          disstate: res.data.disstate,
          disstatecode: res.data.disstatecode,
          discity: res.data.discity,
          dishouseno: res.data.dishouseno,
          disareaname: res.data.disareaname,
          discountry: res.data.discountry,
          iscomposite: res.data.iscomposite,
          insurancereq: res.data.insurancereq,
          insurance: parseFloat(res.data.insurance),
          insuranceamount: parseFloat(res.data.insuranceamount),
          insurancetax: parseFloat(res.data.insurancetax),
          totalinsuranceamount: parseFloat(res.data.totalinsurance),
          einvoice: res.data.einvoicerequired,
          additionalchargeslist: res.data.additionalchares,
          invoiceadditionalcharges: parseFloat(res.data.totaladditionalchares),
          invoiceadditionalchargestax: res.data.additionalchares.reduce(
            (a, b) => (a = a + b.additionalchargestaxamount),
            0
          ),
          samedaydelivery: res.data.samedaydelivery === "TRUE" ? true : false,
          vehiclenum: res.data.vehiclenum,
          transportername: res.data.transportername,
          transporterid: res.data.transporterid,
          distance: parseInt(res.data.distance),
          transid: res.data.transporterid,
          transname: res.data.transname,
          vehicletype: res.data.vehicletype,
          supplytype: res.data.supplytype,
          transportationmode: res.data.transportationmode,
          transactiontype: res.data.transactiontype,
        }, () => {
          this.recomputeTotals();
          CustomerService.retriveCustomer(res.data.custid).then((customerRes) => {
            this.setState({
              custid: customerRes.data.id,
              customer: customerRes.data.companyname,
              debitamount: customerRes.data.debitamount,
              openingbalance: customerRes.data.openingbalance,
              // Address fields from customer might overwrite the invoice ones if we are not careful, 
              // but refreshData should follow the Invoice data primarily.
              convertionreq: res.data.currency === currency ? false : true,
            }, () => this.recomputeTotals());
          });
        });
      });
    }


    CategoryServices.getCategory(currentTenant).then((response) =>
      this.setState({
        CategoryList: response.data.filter((e) => e.categorytype === "Product"),
        ServiceCategoryList: response.data.filter(
          (e) => e.categorytype === "Service"
        ),
      })
    );

    InventoryService.GetWHdata(currentTenant).then((response) => {
      this.setState({ whdata: response.data });
    });

    InventoryService.GetItems(currentTenant).then((response) =>
      this.setState({
        itemList: response.data,
        closingStock:
          response.data.length === 0
            ? 0
            : response.data.find((e) => e.closingstock !== null).closingstock,
      })
    );

    InventoryService.getServices(currentTenant).then((res) => {
      this.setState({ serviceitemList: res.data });
    });

    WarehouseServices.getWarehouses(currentTenant).then((response) =>
      this.setState(
        {
          WarehouseList: response.data,
        },
        () => {
          if (this.state.WarehouseList.length === 1) {
            this.setState({
              warehouse: this.state.WarehouseList[0].name,
              whid: this.state.WarehouseList[0].id,
            });
            DepartmentServices.deptbywarehouse(this.state.WarehouseList[0].id).then((response) => {
              this.setState({
                DepartmentList: response.data
              })
              if (response.data.length === 1) {
                this.setState({
                  department: response.data[0].name,
                  deptid: response.data[0].id
                })
              }
            });
          } else if (dataaccess === "Organization" || dataaccess === "User") {
            this.setState({
              warehouse: this.state.WarehouseList.find((e) => e.id === userwhid)
                .name,
              whid: this.state.WarehouseList.find((e) => e.id === userwhid).id,
              WarehouseList: this.state.WarehouseList.filter(
                (e) => e.id === userwhid
              ),
            });
            DepartmentServices.deptbywarehouse(this.state.WarehouseList.find(e => e.id === userwhid).id).then((response) => {
              this.setState({
                DepartmentList: response.data
              })
              if (response.data.length === 1) {
                this.setState({
                  department: response.data[0].name,
                  deptid: response.data[0].id
                })
              }
            });
          }
        }
      )
    );

    SalesServices.GetAllCurrency().then((response) => {
      this.setState({ currencylist: response.data });
    });

    SalesServices.retriveAllCustomers(currentTenant)
      .then((res) => {
        this.setState({
          custom: res.data.filter((e) =>
            this.state.usercustomers.length === 0
              ? e
              : this.state.usercustomers.includes(e.companyname)
          ),
        });
      })
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });

    SettingsServices.GetSettings(currentTenant).then((response) => {
      this.setState({
        settings: response.data,
        soeditprice: response.data.soeditprice,
        salescalreq: response.data.salescalreq,
        pouploadm: response.data.pouploadm,
        dnrequired: response.data.dnreq,
        autojre: response.data.salesautojre === "YES" ? true : false,
        // valueroundoff:response.data.salesroundoff==="YES"?1:0
        backdateinvoicestatus: response.data.backdateinvoicestatus === "YES" ? true : false,
      });
    });

    MasterService.getParameters(currentTenant).then((res) => {
      this.setState({
        parameters: res.data,
        sizelist: res.data.size,
        colourlist: res.data.colour,
        thicknesslist: res.data.thickness,
        brandslist: res.data.brands,
      });
    });
    MasterService.GetCurrencyOfTenant(currentTenant).then((response) => {
      this.setState({
        basecurrency: response.data.currency,
        currencyid: response.data.id,
        currency: response.data.currency,
        curconversionrate: 1,
      });
    });

    MasterService.getCountries()
      .then((response) =>
        this.setState({
          CountryData: response.data,
        })
      )
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });

    SettingsServices.geteinvoicecredentials(currentTenant).then((response) => {
      this.setState({
        einvoice: response.data.status === "ACTIVE" ? true : false,
      });
    });

    TransporterServices.getTransporters(currentTenant).then((response) =>
      this.setState({ transporterslist: response.data })
    );

    this.setState({
      disname: clientname,
      disphoneno: contactnumber,
      dispincode: czip,
      disstate: cstate,
      disstatecode: cstatecode,
      discity: ccity,
      dishouseno: address,
      disareaname: address2,
      discountry: ccountry,
    });

    if (
      this.props.location.state?.soid !== undefined &&
      this.props.location.state?.soid !== null &&
      this.props.location.state?.soid !== ""
    ) {
      let id = this.props.location.state.soid;
      datalist = [];

      SalesServices.GetDataforInvoice(id).then((response) => {
        this.setState({
          customer: response.data.customer,
          custid: response.data.custid,
          saleorderid: id,
          tcsableamount: 0,
          totaladditionalcharges: 0,
          invoiceadditionalcharges: 0,
          invoiceadditionalchargestax: 0,
          sodata: response.data,
          agent: response.data.agent,
          agentid: response.data.agentid,
          whid: response.data.whid,
          deptid: response.data.deptid,
          currency: response.data.currency,
          curconversionrate: response.data.curconversionrate,
          gsttype: response.data.gsttype,
          taxtype: response.data.taxtype,
          // saleorderitems: response.data.saleorderitems,
          serviceList: response.data.servicelist,
          saleorderitems: response.data.saleorderitems,
          serviceid:
            response.data.sotype === 1
              ? response.data.servicelist.find((e) => e).serviceid
              : "",
          milestones:
            response.data.sotype === 1
              ? response.data.servicelist.find((e) => e).milestones
              : [],
          contracttype:
            response.data.sotype === 1
              ? response.data.servicelist.find((e) => e).contracttype
              : "",
          totaltaxamount: response.data.totaltaxamount,
          totaliv: response.data.totaliv,
          grandtotal: response.data.grandtotalproducttotal,
          grandservicetotal: response.data.grandservicetotal,
          sotype: response.data.sotype,
          creditperiod:
            response.data.creditperiod === null ||
              response.data.creditperiod === undefined
              ? 0
              : response.data.creditperiod,
          accepteditems:
            this.state.pagename === "New Proforma Invoice" ||
              response.data.sotype === 2
              ? response.data.saleorderitems
              : [],
          completed:
            response.data.sotype === 1 &&
              this.state.pagename === "New Proforma Invoice"
              ? response.data.servicelist.find((e) => e).milestones[0]
              : "",
          addservice: response.data.sotype === 2 ? true : false,
          pricevariance: response.data.pricevariance,
        });

        CustomerService.retriveCustomer(response.data.custid).then((res) =>
          this.setState({
            custid: res.data.id,
            customer: res.data.companyname,
            debitamount: res.data.debitamount,
            openingbalance: res.data.openingbalance,
            adjustopen: false,
            adjustdebit: res.data.debitamount > 0 ? true : false,
            name: res.data.companyname,
            phoneno: res.data.contactnumber,
            pincode: res.data.zip,
            state: res.data.statename,
            city: res.data.cityname,
            houseno: res.data.address,
            areaname: res.data.address2,
            country: res.data.countryname,
            statecode: res.data.statecode,
            currency: res.data.currency,
            currencyid: this.state.currencylist.find(
              (e) => e.currency === res.data.currency
            ).id,
            taxtype: res.data.taxtype,
            gsttype:
              res.data.statename === cstate && res.data.countryname === "India"
                ? "INTRASTATE"
                : "INTERSTATE",
            convertionreq: res.data.currency === currency ? false : true,
          })
        );
      });
    }
  }

  handleTaxtypeChange = (value, values) => {
    this.setState({ taxtype: values })
  }
  handleGsttypeChange = (value, values) => {
    this.setState({ gsttype: values })
  }

  handleCurrency = (value, values) => {
    if (value !== '') {
      this.setState({ currencyid: values.id, currency: values.currency, curconversionrate: 1 })
      if (values.currency !== this.state.basecurrency) {
        this.setState({ convertionreq: true })
      } else {
        this.setState({ convertionreq: false })
      }
    }
  }

  handleRecurringEndDateChange = (date) => {
    const currentCustom = dayjs(
      this.state.recurringenddate || new Date()
    );
    const nextCustomDate = dayjs(date)
      .hour(currentCustom.hour())
      .minute(currentCustom.minute())
      .second(currentCustom.second());

    const nextCustomMoment = moment(
      nextCustomDate.toDate()
    );

    this.setState({
      recurringenddate: nextCustomDate.toDate(),
    });
  }
  handleInvoiceRecurringPeriodChange = (e) => {
    this.setState({ recurringperiod: e.target.value })
  }

  handleInvoiceRecurringConfirmationChange = (e) => {
    this.setState({ recurringconfirm: e.target.value })
  }

  handleRecurringEndTimeChange = (e) => {
    // const [hours, minutes] =
    //   e.target.value.split(":");
    // const newDate = dayjs(
    //   this.state.recurringenddate || new Date()
    // )
    //   .hour(parseInt(hours))
    //   .minute(parseInt(minutes));
    // this.setState({
    //     recurringenddate: newDate.toDate()
    // });

    const [hours, minutes] = e.target.value.split(':');
    const newDate = dayjs(this.state.recurringenddate || new Date()).hour(parseInt(hours)).minute(parseInt(minutes));
    this.setState({
      recurringenddate: newDate.toDate(),
    });
  }


  componentDidMount() {
    UomServices.getUOM(currentTenant).then((response) =>
      this.setState({
        UOMList: response.data,
      })
    );

    TaxServices.getTaxes(currentTenant).then(response => this.setState({ taxesList: response.data }))

    UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
      this.setState({
        usercustomers:
          res.data === "" || res.data === undefined
            ? []
            : res.data.customers.split(","),
      })
    );
    this.refreshData();
    datalist = [];
  }

  validate(values) {
    let errors = {};
    //  let isError = false;
    var num = /^[0-9]/;

    if (this.state.customer === "") {
      errors.customer = "Please Select Customer";
    }

    if (
      this.state.quantity === "" ||
      this.state.quantity === undefined ||
      this.state.quantity === "0" ||
      parseFloat(this.state.quantity) <= 0 ||
      !num.test(parseFloat(this.state.quantity))
    ) {
      errors.quantity = "Quantity is required";
    }
    if (
      (this.state.price === "" ||
        this.state.price === undefined ||
        this.state.price === "0" ||
        this.state.price === 0)
    ) {
      errors.price = "Price is required";
    }

    if (this.state.itemname === "" || this.state.itemname === undefined) {
      errors.itemname = "Item/Service Name is required";
    }

    return errors;
  }

  finalTotal = () => {
    let cost = (isInvalid.includes(this.state.price) ? 0 : parseFloat(this.state.price))
    let markup = (isInvalid.includes(this.state.markup1) ? 0 : parseFloat(this.state.markup1))
    let variance = (isInvalid.includes(this.state.pricevariance) ? 0 : parseFloat(this.state.pricevariance))

    let baseWithMarkup = cost + markup
    let priceWithVariance = baseWithMarkup + (baseWithMarkup * variance / 100)

    let discount = this.state.discounttype === "%" ? ((priceWithVariance) * ((isInvalid.includes(this.state.discount) ? 0 : parseFloat(this.state.discount)) / 100)) : ((isInvalid.includes(this.state.discountamount) ? 0 : parseFloat(this.state.discountamount)))
    let total = priceWithVariance - discount
    let tax = (total) * ((isInvalid.includes(this.state.tax) ? 0 : parseFloat(this.state.tax)) / 100)
    let qty = isInvalid.includes(this.state.quantity) ? 0 : parseFloat(this.state.quantity)
    return ((total + tax) * qty).toFixed(2)
  }
  convertedfinalTotal = () => {
    let total = this.finalTotal()
    return (total * (isInvalid.includes(this.state.curconversionrate) ? 0 : parseFloat(this.state.curconversionrate))).toFixed(2)
  }

  render() {
    let {
      custom,
      customer,
      custid,
      saleorderdata,
      itemid,
      itemname,
      quantity,
      orderedquantity,
      grandtotal,
      status,
      saleorderitems,
      poid,
      DnIDList,
      currencylist,
      currencyid,
      curconversionrate,
      tcs,
      tcsreq,
      tcsamount,
      pendingquantity,
      creditperiod,
      additionalchargeslist,
      additionalcharges,
      additionalchargestax,
      totaladditionalcharges,
      additionalchargestaxamount,
      natureofcharge,
      vehiclenum,
      distance,
      transporterid,

      WarehouseList,
      DepartmentList,
      CategoryList,
      filteritemlist,
      sizelist,
      colourlist,
      brandslist,
      filterserv,
      serviceitemList,
      serviceList,
      service,
      serviceid,
      ServiceCategoryList,
      servicecategory,
      servicecatid,
      servicetax,
      servicecode,
      servicecost,
      servicecostconv,
      servicecgst,
      servicesgst,
      serviceigst,
      servicegst,
      servicevat,
      servicecostwttax,
      servicecostwttaxconv,
      servicetaxamount,
      servicedescription,
      servicetotal,
      grandservicetotal,
      serviceerr,
      markup1,
      markup,
      invoiceremarks,
      basecurrency,
      duedate,
      customcreatedAt,
      openDuePicker,
      openCustomPicker
    } = this.state;
    return (
      <div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.loader}
        // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div className="">
          <Formik
            initialValues={{
              custom,
              customer,
              custid,
              saleorderdata,
              itemid,
              itemname,
              quantity,
              orderedquantity,
              grandtotal,
              status,
              saleorderitems,
              poid,
              DnIDList,
              currencylist,
              currencyid,
              curconversionrate,
              tcs,
              tcsreq,
              tcsamount,
              pendingquantity,
              creditperiod,
              additionalchargeslist,
              additionalcharges,
              additionalchargestax,
              totaladditionalcharges,
              additionalchargestaxamount,
              natureofcharge,
              vehiclenum,
              distance,
              transporterid,

              WarehouseList,
              DepartmentList,
              CategoryList,
              filteritemlist,
              sizelist,
              colourlist,
              brandslist,
              filterserv,
              serviceitemList,
              serviceList,
              service,
              serviceid,
              ServiceCategoryList,
              servicecategory,
              servicecatid,
              servicetax,
              servicecode,
              servicecost,
              servicecostconv,
              servicecgst,
              servicesgst,
              serviceigst,
              servicegst,
              servicevat,
              servicecostwttax,
              servicecostwttaxconv,
              servicetaxamount,
              servicedescription,
              servicetotal,
              grandservicetotal,
              serviceerr,
              markup1,
              markup,
              invoiceremarks
            }}
            validateOnChange={false}
            validate={this.validate}
            onSubmit={this.onSubmit}
            enableReinitialize={true}
          >
            {({ setFieldValue, values, errors, touched }) => (
              <Form className="UI-form">

                {/* SECTION: Select Customer Information */}
                <div className="UI-form-section">
                  <h3 className="UI-section-title" style={{ backgroundColor: '#f4f4f4', padding: '12px' }}>
                    Select Customer Information
                  </h3>

                  {/* Row 1: Primary Selection & Dates */}
                  <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', marginBottom: '10px' }}>
                    <div className="UI-form-group">
                      <AutoCompeteField id="customer" name="customer" type="text" options={custom} valueKey={"id"} labelKey={"companyname"} value={this.state.custid} label={`Customer`} required placeholder="Select Customer Name" onChange={this.handleCustomer} error={errors?.customer} />
                    </div>

                    {/* Hide Sale Order for Non-Inventory Invoice as per "Direct Invoice" design req */}
                    {/* {this.state.invtype !== "Direct Invoice" && (
                      <div className="UI-form-group">
                        <label className="UI-label">Sale Order</label>
                        {this.state.pagename === "Edit Invoice" ? (
                          <input
                            type="text"
                            className="UI-input UI-input-disabled"
                            value={this.state.saleorderid}
                            disabled
                          />
                        ) : (
                          <Autocomplete
                            id="saleorder"
                            name="saleorder"
                            options={saleorderdata}
                            getOptionLabel={(option) => option}
                            value={saleorderdata.find(e => e === this.state.saleorderid) || null}
                            onChange={this.handleSaleOrder}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref}>
                                <input
                                  type="text"
                                  {...params.inputProps}
                                  className="UI-input"
                                  placeholder="Select sale order"
                                />
                              </div>
                            )}
                          />
                        )}
                      </div>
                    )} */}

                    <div className="UI-form-group">
                      <TextfieldComponent
                        type="number"
                        label={"Credit Period (Days)"}
                        value={this.state.creditperiod}
                        onChange={(e) => {
                          const days = isInvalid.includes(e.target.value) ? 0 : parseInt(e.target.value);
                          const baseDate = this.state.SDdate && this.state.customcreatedAt
                            ? moment(this.state.customcreatedAt)
                            : moment(new Date());

                          const currentDue = this.state.duedate ? moment(this.state.duedate) : moment(new Date());
                          const nextDue = baseDate.add(days, 'days')
                            .hour(currentDue.hour())
                            .minute(currentDue.minute())
                            .second(currentDue.second());

                          this.setState({
                            creditperiod: days,
                            duedate: nextDue.toDate()
                          });
                        }}
                        min="0"
                      />
                    </div>

                    <div className="UI-form-group">
                      <label className="UI-label">Due Date</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            showTodayButton
                            value={this.state.duedate ? dayjs(this.state.duedate) : null}
                            open={this.state.openDuePicker}
                            onOpen={() => this.setState({ openDuePicker: true })}
                            onClose={() => this.setState({ openDuePicker: false })}
                            minDate={
                              this.state.SDdate && this.state.customcreatedAt
                                ? dayjs(this.state.customcreatedAt)
                                : dayjs()
                            }
                            onChange={(date) => {
                              const currentDue = dayjs(this.state.duedate || new Date());
                              const nextDueDate = dayjs(date)
                                .hour(currentDue.hour())
                                .minute(currentDue.minute())
                                .second(currentDue.second());

                              const nextDueMoment = moment(nextDueDate.toDate());
                              const baseDate = this.state.SDdate && this.state.customcreatedAt
                                ? moment(this.state.customcreatedAt)
                                : moment(new Date());

                              // Calculate days difference ignoring time for credit period
                              const diffDays = nextDueMoment.clone().startOf('day').diff(baseDate.clone().startOf('day'), 'days');

                              this.setState({
                                duedate: nextDueMoment.toDate(),
                                creditperiod: diffDays >= 0 ? diffDays : 0
                              });
                            }}
                            renderInput={(params) => (
                              <div
                                style={{ position: "relative", flex: 1, cursor: "pointer" }}
                                onClick={() => this.setState({ openDuePicker: true })}
                              >
                                <input
                                  {...params.inputProps}
                                  ref={params.inputRef}
                                  className="UI-input"
                                  placeholder="Date"
                                  style={{ width: "100%", paddingRight: "40px", cursor: "pointer" }}
                                  readOnly
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    display: "flex",
                                    alignItems: "center"
                                  }}
                                >
                                  {params.InputProps.endAdornment}
                                </div>
                              </div>
                            )}
                          />
                        </LocalizationProvider>
                        <input
                          type="time"
                          className="UI-input"
                          style={{ width: "110px" }}
                          value={this.state.duedate ? dayjs(this.state.duedate).format("HH:mm") : "00:00"}
                          onChange={(e) => {
                            const [hours, minutes] = e.target.value.split(':');
                            const newDate = dayjs(this.state.duedate || new Date()).hour(parseInt(hours)).minute(parseInt(minutes));
                            this.setState({ duedate: newDate.toDate() });
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className=" col-md-12 m-1 p-0">
                    <div className="tw-flex tw-gap-2.5 tw-mb-4 tw-flex-wrap tw-px-1">
                      <RoundedTabButton size="sm" label={"With Tax"} checked={this.state.taxrequired} onClick={() => this.setState(prev => ({ taxrequired: !prev.taxrequired }))} />
                      <RoundedTabButton size="sm" label={"Custome Invoice Date"} checked={this.state.SDdate} onClick={() => this.setState(prev => ({ SDdate: !prev.SDdate }))} />
                      {/* <RoundedTabButton label={"Recurring Invoice"} checked={this.state.recurring} onClick={() => this.setState(prev => ({ recurring: !prev.recurring }))} /> */}
                    </div>
                  </div>

                  {/* Row 2: Toggles and Conditional Fields */}
                  <div
                    className="UI-form-row-flexible"
                    style={{
                      display: 'flex',
                      gap: '15px',
                      alignItems: 'bottom',
                      flexWrap: 'nowrap',
                      overflowX: 'auto',
                      paddingBottom: '4px'
                    }}
                  >
                    {/* Toggles Group - Explicit 25px gap as requested */}
                    {/* <div className="UI-form-group" style={{ minWidth: 'fit-content', flexShrink: 1 }}>
                        <FormControlLabel
                          labelPlacement="start"
                          className="os-switch-label"
                          style={{ gap: '4px' }}
                          control={
                            <OSSwitch
                              checked={this.state.taxrequired}
                              onChange={(checked) => this.setState({ taxrequired: checked })}
                              disabled={this.state.accepteditems && this.state.accepteditems.length > 0}
                            />
                          }
                          label="With Tax"
                        />
                      </div>

                      <div className="UI-form-group" style={{ minWidth: 'fit-content', flexShrink: 1 }}>
                        <FormControlLabel
                          labelPlacement="start"
                          style={{ gap: '4px' }}
                          className="os-switch-label"
                          control={
                            <OSSwitch
                              checked={this.state.SDdate}
                              onChange={() => this.setState({ SDdate: !this.state.SDdate })}
                            />
                          }
                          label="Custom Date"
                        />
                      </div> */}

                    {/* <div className="UI-form-group" style={{ minWidth: 'fit-content', flexShrink: 1 }}>
                        <FormControlLabel
                          labelPlacement="start"
                          className="os-switch-label"
                          style={{ gap: '4px' }}
                          control={
                            <OSSwitch
                              checked={this.state.multiCurrency}
                              onChange={this.handleMultiCurrencyToggle}
                            />
                          }
                          label="Multi Currency"
                        />
                      </div> */}

                    {/* Conditional: Tax Type display (Placed before date fields to match Invoice.jsx patterns) */}
                    {this.state.taxrequired === true && <>
                      <div className="UI-form-group" style={{ minWidth: '120px', marginLeft: '12px', flexShrink: 1 }}>
                        <label className="UI-label">Tax Type</label>
                        {/* <input
                                                                    type="text"
                                                                    className="UI-input UI-input-disabled"
                                                                    value={this.state.taxtype}
                                                                    disabled
                                                                /> */}
                        <Autocomplete
                          id="currency"
                          name="currency"
                          options={this.state.taxtypelist}
                          getOptionLabel={(option) => option}
                          value={this.state.taxtype ? this.state.taxtypelist.find(e => e === this.state.taxtype) : null}
                          onChange={this.handleTaxtypeChange}
                          disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)}
                          renderInput={(params) => (
                            <div ref={params.InputProps.ref} style={{ position: 'relative', width: '200px' }}>
                              <input
                                type="text"
                                {...params.inputProps}
                                className="UI-input"
                                placeholder="Select Taxtype"
                                value={this.state.taxtype}
                                style={{
                                  width: '100%',
                                  // paddingRight: this.state.currency && this.state.currency !== this.state.basecurrency ? '30px' : undefined
                                }}
                              />
                            </div>
                          )}
                        />
                      </div>
                      {ccountry === "India" && this.state.taxtype === "GST" &&
                        <div className="UI-form-group" style={{ minWidth: '120px', marginLeft: '12px', flexShrink: 1 }}>
                          <label className="UI-label">GST Type</label>
                          {/* <input
                                                                type="text"
                                                                className="UI-input UI-input-disabled"
                                                                value={this.state.taxtype}
                                                                disabled
                                                            /> */}
                          <Autocomplete
                            id="currency"
                            name="currency"
                            options={this.state.gsttypelist}
                            getOptionLabel={(option) => option}
                            value={this.state.gsttype}
                            onChange={this.handleGsttypeChange}
                            disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref} style={{ position: 'relative', width: '200px' }}>
                                <input
                                  type="text"
                                  {...params.inputProps}
                                  className="UI-input"
                                  placeholder="Select Taxtype"
                                  value={this.state.gsttype}
                                  style={{
                                    width: '100%',
                                    // paddingRight: this.state.currency && this.state.currency !== this.state.basecurrency ? '30px' : undefined
                                  }}
                                />
                              </div>
                            )}
                          />
                        </div>}
                    </>
                    }

                    {/* Conditional: Custom Invoice Date (Placed before Multi Currency to match Invoice.jsx) */}
                    {this.state.SDdate && this.state.backdateinvoicestatus && (<>
                      <div className="UI-form-group">
                        <label className="UI-label">Custom Invoice Date</label>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              disableFuture
                              showTodayButton
                              minDate={(() => {
                                let minDate;
                                if (typeof transactionFrom !== "undefined" && transactionFrom) {
                                  minDate = dayjs(transactionFrom);
                                } else if (this.state.sodata?.createdAt) {
                                  minDate = dayjs(this.state.sodata.createdAt);
                                } else {
                                  minDate = dayjs("1900-01-01");
                                }
                                return minDate;
                              })()}
                              maxDate={dayjs()}
                              value={this.state.customcreatedAt ? dayjs(this.state.customcreatedAt) : null}
                              open={this.state.openCustomPicker}
                              onOpen={() => this.setState({ openCustomPicker: true })}
                              onClose={() => this.setState({ openCustomPicker: false })}
                              onChange={(date) => {
                                const currentCustom = dayjs(this.state.customcreatedAt || new Date());
                                const nextCustomDate = dayjs(date)
                                  .hour(currentCustom.hour())
                                  .minute(currentCustom.minute())
                                  .second(currentCustom.second());

                                const currentDue = dayjs(this.state.duedate || new Date());
                                const nextDue = dayjs(nextCustomDate.toDate()).add(this.state.creditperiod, 'day')
                                  .hour(currentDue.hour())
                                  .minute(currentDue.minute())
                                  .second(currentDue.second());

                                this.setState({
                                  customcreatedAt: nextCustomDate.toDate(),
                                  duedate: nextDue.toDate(),
                                });
                                SalesServices.GetLatestInvoiceNumberOfFinancialYear(dayjs(nextCustomDate.toDate()).format("YYYY"), dayjs(nextCustomDate.toDate()).format("MM"), currentTenant).then(res => {
                                  if (res.data) {
                                    this.setState({
                                      finacialLatestInvoiceNumber: res.data.invNumber === 0 ? null : res.data.nextInvoiceId,
                                      invNumber: res.data.invNumber
                                    })
                                  }
                                })
                              }}
                              renderInput={(params) => (
                                <div
                                  style={{ position: "relative", width: "200px", cursor: "pointer" }}
                                  onClick={() => this.setState({ openCustomPicker: true })}
                                >
                                  <input
                                    {...params.inputProps}
                                    ref={params.inputRef}
                                    className="UI-input"
                                    placeholder="Date"
                                    style={{ width: "100%", paddingRight: "40px", cursor: "pointer" }}
                                    readOnly
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      display: "flex",
                                      alignItems: "center"
                                    }}
                                  >
                                    {params.InputProps.endAdornment}
                                  </div>
                                </div>
                              )}
                            />
                          </LocalizationProvider>
                          <input
                            type="time"
                            className="UI-input"
                            style={{ width: "110px" }}
                            value={this.state.customcreatedAt ? dayjs(this.state.customcreatedAt).format("HH:mm") : "00:00"}
                            onChange={(e) => {
                              const [hours, minutes] = e.target.value.split(':');
                              const newDate = dayjs(this.state.customcreatedAt || new Date()).hour(parseInt(hours)).minute(parseInt(minutes));

                              const currentDue = dayjs(this.state.duedate || new Date());
                              const nextDue = dayjs(newDate.toDate()).add(this.state.creditperiod, 'day')
                                .hour(currentDue.hour())
                                .minute(currentDue.minute())
                                .second(currentDue.second());

                              this.setState({
                                customcreatedAt: newDate.toDate(),
                                duedate: nextDue.toDate(),
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="UI-form-group col-md-3">
                        {this.state.finacialLatestInvoiceNumber === null ? <TextfieldComponent value={this.state.invNumber} label={"Enter Financial Invoice Number"} onChange={(e) => this.setState({ invNumber: e.target.value })} /> : <TextfieldComponent value={this.state.finacialLatestInvoiceNumber} label={"Next Financial Invoice Id"} disabled />}
                      </div>
                    </>)}

                    {this.state.recurring && <div className="UI-form-group">
                      <div className="col-md-3">
                        <DatePickerField disablePast={true} minDate={transactionFrom ? dayjs(transactionFrom) : dayjs("1900-01-01")} label={"Recurring End Date"} value={this.state.recurringenddate} onDateChange={this.handleRecurringEndDateChange} timePicker={true} onTimeChange={this.handleRecurringEndTimeChange} />
                      </div>
                      <div className="col-md-2">
                        <SelectField label={"Recurring Period"} lableKey={null} lableValue={null} list={["Daily", "Weekly", "Monthly", "Quarterly", "HalfYearly", "Yearly"]} value={this.state.recurringperiod} onChange={this.handleInvoiceRecurringPeriodChange} />
                      </div>
                      <div className="col-md-3">
                        <SelectField label={"Recurring Invocie Confirmation"} lableKey={null} lableValue={null} list={["Auto", "Manual"]} value={this.state.recurringconfirm} onChange={this.handleInvoiceRecurringConfirmationChange} />
                      </div>
                      <div className="col-md-12 text-xs tw-text-gray-600"><span className="mr-1">ⓘ</span> {this.state.recurringconfirm === "Auto" ? `Tax invoices will be generated ${this.state.recurringperiod} (no approval required).` : `Temporary invoices will be generated ${this.state.recurringperiod}, approval will be required to generate a tax invoice.`}</div>
                    </div>}

                    {/* Conditional: Multi Currency Section */}
                    {/* {this.state.multiCurrency && ( */}
                    <div className="UI-form-group" style={{ marginTop: '0px' }}>
                      <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto', alignItems: 'center', gap: '12px', width: 'fit-content' }}>
                        {/* First column: Invoice Currency */}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <label className="UI-label">Invoice Currency</label>
                          <Autocomplete
                            id="currency-select"
                            name="currency"
                            options={currencylist}
                            getOptionLabel={(option) => option.currency}
                            value={this.state.currency ? currencylist.find(e => e.currency === this.state.currency) || null : null}
                            onChange={this.handleCurrency}
                            disabled={!isInvalid.includes(this.state.grandtotal)}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref} style={{ position: 'relative', width: '200px' }}>
                                <input
                                  type="text"
                                  {...params.inputProps}
                                  className="UI-input"
                                  placeholder="Select currency"
                                  style={{
                                    width: '100%',
                                    paddingRight: this.state.currency && this.state.currency !== this.state.basecurrency ? '30px' : undefined
                                  }}
                                />
                                {this.state.currency && this.state.currency !== this.state.basecurrency && (
                                  <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', fontSize: '13px', color: '#666' }}>1</span>
                                )}
                              </div>
                            )}
                          />
                        </div>

                        {/* Equals sign column - only shown when currencies differ */}
                        {this.state.currency !== this.state.basecurrency && (
                          <div style={{ alignSelf: 'center', marginTop: '20px' }}>
                            <span style={{ fontSize: '16px', fontWeight: 500, lineHeight: 1 }}>=</span>
                          </div>
                        )}

                        {/* Third column: Conversion Rate (only shown when currencies differ) */}
                        {this.state.currency !== this.state.basecurrency && (
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label className="UI-label">Conversion Rate ({basecurrency})</label>
                            <div style={{ position: 'relative', width: '260px' }}>
                              <input
                                type="number"
                                className="UI-input"
                                value={this.state.curconversionrate}
                                disabled={!isInvalid.includes(this.state.grandtotal)}
                                onChange={(e) => this.setState({ curconversionrate: e.target.value })}
                                style={{ width: '100%', paddingRight: '55px' }}
                              />
                              <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', fontSize: '13px', color: '#666' }}>
                                {this.state.basecurrency}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                </div>

                {/* ============================================================ */}
                {/* SECTION: Product / Service Entry                              */}
                {/* ============================================================ */}
                <div className="UI-form-section">
                  <h3 className="UI-section-title" style={{ backgroundColor: '#f4f4f4', padding: '12px' }}>
                    Products / Services (Manual Entry)
                  </h3>

                  <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', marginBottom: '10px' }}>

                    {/* Item/Service Name */}
                    <div className="UI-form-group">
                      <TextfieldComponent
                        id="itemname"
                        type="text"
                        label={"Product / Service"}
                        required
                        value={this.state.itemname}
                        onChange={(e) => this.setState({ itemname: e.target.value })}
                        placeholder="Enter item or service"
                        error={errors?.itemname}
                      />

                    </div>

                    {/* HSN / Item Code */}
                    <div className="UI-form-group">
                      <TextfieldComponent
                        type="text"
                        label={this.state.taxtype === 'VAT' ? 'Item Code' : 'HSN / Item Code'}
                        value={this.state.hsn}
                        onChange={(e) => this.setState({ hsn: e.target.value })}
                        placeholder={this.state.taxtype === 'VAT' ? 'Enter Item Code' : 'Enter HSN/SAC'}
                      />
                    </div>

                    {/* Price */}
                    <div className="UI-form-group">
                      <TextfieldComponent
                        id="price"
                        type="number"
                        label={`Price`}
                        value={this.state.price === '' ? '' : this.state.price}
                        onChange={(e) => this.setState({ price: isInvalid.includes(e.target.value) ? 0 : e.target.value, totalpricewtax: '' })}
                        placeholder="0.00"
                        required
                        error={errors?.price}
                        prefix={this.state.currency}
                      />
                    </div>

                    {/* Markup (Moved here from 8th position) */}
                    {this.state.settings && this.state.settings.allowextramakup === 'YES' && (
                      <div className="UI-form-group">
                        <TextfieldComponent
                          type="number"
                          label="Markup per Unit"
                          value={this.state.markup1}
                          onChange={this.handlemarkup1Change}
                          placeholder="0"
                          prefix={this.state.currency}
                        />
                      </div>
                    )}

                    {/* Quantity */}
                    <div className="UI-form-group">
                      <TextfieldComponent
                        id="quantity"
                        type="number"
                        label={`Quantity`}
                        value={this.state.quantity}
                        onChange={(e) => this.setState({ quantity: e.target.value ? e.target.value : 0, totalpricewtax: 0 })}
                        placeholder="0"
                        error={errors.quantity}
                      />
                    </div>

                    {/* UOM */}
                    <div className="UI-form-group">
                      <AutoCompeteField id="uom" name="uom" label={"Unit of Measure"} options={this.state.UOMList} labelKey={"name"} valueKey={"name"} value={this.state.uom} onChange={(val, newValue) => newValue && this.setState({ uom: newValue.name })} required error={errors?.uom} />
                    </div>

                    {/* Discount % */}
                    <div className="UI-form-group">
                      {/* <label className="UI-label">Discount (%)</label>
                      <input
                        type="number"
                        className="UI-input"
                        value={this.state.discount}
                        onChange={(e) => this.setState({ discount: e.target.value })}
                        placeholder="0"
                        min="0"
                      /> */}
                      <TextFeildWithSelect label={`Discount per ${this.state.uom ? this.state.uom : "UNIT"}`} value={this.state.discounttype === "%" ? this.state.discount : this.state.discountamount} onChange={this.handleDiscountChange} list={["%", this.state.currency]} selectvalue={this.state.discounttype} onSelectChange={this.handleSelectDiscountType} />

                    </div>

                    {/* Tax % (Moved here from 4th position) */}
                    {this.state.taxrequired && (
                      <div className="UI-form-group">
                        {/* <TextfieldComponent
                          type="number"
                          label="Tax (%)"
                          value={this.state.tax}
                          onChange={(e) => this.setState({ tax: e.target.value })}
                          placeholder="0"
                          min="0"
                        /> */}
                        <SelectField id="tax" label={`Select Tax(%)`} list={[...this.state.taxesList.map((e => { return { ...e, description: e.tax } }))]} lableKey={"description"} lableValue={"tax"} name="tax" value={this.state.tax} onChange={(e) => this.setState({ tax: e.target.value })} />
                      </div>

                    )}

                    {/* Total Price (read-only) */}
                    <div className="UI-form-group">
                      <TextfieldComponent
                        type="text"
                        label="Total"
                        value={this.finalTotal()}
                        disabled
                        prefix={this.state.currency}
                      />
                    </div>

                    {/* Converted Total (if multi-currency) */}
                    {this.state.convertionreq && this.state.currency !== this.state.basecurrency && (
                      <div className="UI-form-group">
                        <TextfieldComponent
                          type="text"
                          label={`Total`}
                          value={this.convertedfinalTotal()}
                          disabled
                          prefix={this.state.basecurrency}
                        />
                      </div>
                    )}

                  </div>

                  {/* Description */}
                  <div className="UI-form-group">
                    <TextareaField
                      label="Description / Specifications"
                      rows={2}
                      value={this.state.description}
                      onChange={(e) => this.setState({ description: e.target.value })}
                      placeholder="Enter description or specifications"
                      required
                      error={errors?.description}
                    />
                  </div>

                  {/* E-Invoice Composite */}
                  {this.state.einvoice && (this.state.iscomposite === false || this.state.accepteditems.length !== 0) && (
                    <div style={{ marginBottom: '12px' }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.iscomposite}
                            onChange={() => this.setState({ iscomposite: !this.state.iscomposite })}
                            name="iscomposite"
                            color="primary"
                          />
                        }
                        label="Is Composite Item"
                      />
                      {this.state.iscomposite && (
                        <span style={{ fontSize: '0.8rem', color: '#dc2626' }}>
                          &nbsp;Note: Reverse GST will be applicable on this invoice
                        </span>
                      )}
                    </div>
                  )}

                  {/* Add Item Button */}
                  {this.state.availabelcredit < 0 ? (
                    <>
                      <p style={{ color: '#dc2626', fontSize: '0.85rem', margin: '0 0 8px 0' }}>
                        Exceeded Credit Value — Request for credit
                      </p>
                      <div className="UI-form-group" style={{ maxWidth: '220px', marginBottom: '12px' }}>
                        <label className="UI-label">Request Credit Amount</label>
                        <input
                          type="number"
                          className="UI-input"
                          value={this.state.requestcredit}
                          onChange={(e) => this.setState({ requestcredit: parseFloat(e.target.value) })}
                          placeholder="Enter amount"
                        />
                      </div>
                      <button
                        className="btn btn-sm hovbuttonColour"
                        onClick={this.handleRequestCredit}
                        type="button"
                        style={{ marginRight: '8px' }}
                      >
                        Request Credit Value
                      </button>
                    </>
                  ) : (
                    <div className="UI-btn-actions" style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                      <button
                        className="UI-btn UI-btn-primary"
                        type="submit"
                      >
                        {this.state.itemid && this.state.itemid !== "" ? 'Update Item' : 'Add Item'}
                      </button>
                      <button
                        className="UI-btn UI-btn-outline"
                        type="button"
                        onClick={this.clearCurrentItem}
                      >
                        Clear
                      </button>
                    </div>
                  )}
                </div>









                {/* <div className="form-group col-md-12">
                  <Accordion ref={this.mySectionRef} >

                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      style={{ backgroundColor: '#e8ecef' }}
                    >
                      <Typography>Advance Options</Typography>
                    </AccordionSummary>
                    <AccordionDetails>

                      <FieldArray
                        name="addsettings"
                        render={arrayHelpers => (
                          <div className="form-group col-md-12">
                            <div className="form-row">
                              <fieldset
                                className="form-group col-md-3 mt-2 m-0"
                              >
                                <FormGroup row>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.convertionreq}
                                        onChange={(e) => this.setState({ convertionreq: e.target.checked })}
                                        name="taxrequired"
                                        color="primary"
                                        disabled={this.state.accepteditems && this.state.accepteditems.length > 0}
                                      />
                                    }
                                    label="Multi Currency Required?"
                                  />
                                </FormGroup>
                              </fieldset>

                              {this.state.convertionreq === true ? <>
                                <fieldset className="form-group col-md-2" >
                                  <FormikTextField
                                    className="form-control"
                                    type="text"
                                    value={this.state.basecurrency}
                                    name="basecurrency"
                                    label="Base Currency"
                                    variant="standard"
                                    fullWidth
                                    disabled
                                  /> </fieldset>

                                <fieldset className="form-group col-md-2">
                                  <Autocomplete
                                    id="subaccount"
                                    className="subacc-select"
                                    name="currency"
                                    options={currencylist}
                                    getOptionLabel={(option) => option.currency}


                                    value={values.currency ? undefined : undefined}
                                    onChange={this.handleCurrency}
                                    disabled={this.state.accepteditems && this.state.accepteditems.length > 0}
                                    renderInput={params => (
                                      <FormikTextField
                                        {...params}
                                        className="form-control"
                                        type="text"
                                        name="currency"
                                        value={this.state.currency}
                                        // onBlur={(e) =>{this.handleCurrency(e.target.value,values)}}
                                        label={`Select Currency (${this.state.currency})`}
                                        variant="standard"
                                        fullWidth
                                      />
                                    )}
                                  />
                                </fieldset>

                                {this.state.currency === this.state.basecurrency || this.state.currency === undefined || this.state.currency === '' ? '' :
                                  <fieldset className="form-group col-md-2" >

                                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                                      <InputLabel htmlFor="standard-adornment-amount">{`Enter Conversion rate`}</InputLabel>
                                      <Input
                                        id="standard-adornment-amount"
                                        value={this.state.curconversionrate}
                                        type="number"
                                        onChange={(e) => this.setState({ curconversionrate: e.target.value })}
                                        // onFocus={this.oncurrencyconvtfocus}
                                        startAdornment={<InputAdornment position="start">1 {this.state.basecurrency} =</InputAdornment>}
                                        endAdornment={<InputAdornment position="end"> {this.state.currency}</InputAdornment>}
                                        disabled={this.state.accepteditems && this.state.accepteditems.length > 0}
                                      />
                                    </FormControl>
                                  </fieldset>
                                }
                              </> : ""}
                            </div>
                            <div className="form-row">
                              <fieldset className="form-group col-md-3 mt-2 m-0">
                                <FormGroup row>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.taxrequired}
                                        onChange={(e) => this.setState({ taxrequired: e.target.checked })}
                                        name="taxrequired"
                                        color="primary"
                                        disabled={this.state.accepteditems && this.state.accepteditems.length > 0}
                                      />
                                    }
                                    label="Tax is Applicable?"
                                  />
                                </FormGroup>
                              </fieldset>
                              {this.state.taxrequired === true ?
                                <fieldset className="form-group col-md-3 m-0">
                                  <FormControl variant="standard" className="w-100">
                                    <InputLabel id="demo-simple-select-standard-label">Tax Type :&nbsp; {this.state.taxtype}</InputLabel>
                                  </FormControl>
                                </fieldset>
                                : ''
                              }
                            </div>
                            <fieldset className="form-group col-md-12 m-0" />
                          </div>
                        )}
                      />

                    </ AccordionDetails>
                  </Accordion>
                </div> */}



                {this.state.saleorderid === "" ? (
                  this.state.invtype === "Direct Invoice" ? (
                    <>
                      {this.state.sotype === 0 ||
                        this.state.sotype === 2 ? (
                        ""
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  <>
                  </>
                )}
                {this.state.accepteditems.length > 0 && (
                  <div className="UI-table-container" style={{ marginTop: '30px' }}>
                    <div className="UI-table-header-toolbar">
                      <h4 className="UI-section-title">Added Items / Services</h4>
                    </div>
                    <table className="UI-table">
                      <thead className="UI-table-header">
                        <tr>
                          <th className="UI-th" style={{ width: '150px' }}>Item Name</th>
                          {this.state.taxtype !== "NA" && <th className="UI-th" style={{ width: '100px' }}>HSN</th>}
                          <th className="UI-th UI-amount">Price ({currency})</th>
                          {currency !== this.state.currency && <th className="UI-th UI-amount">Price ({this.state.currency})</th>}
                          {currency !== this.state.currency && <th className="UI-th" style={{ width: '80px' }}>Price Var (%)</th>}
                          <th className="UI-th">Description</th>
                          <th className="UI-th" style={{ width: '70px' }}>Qty</th>
                          <th className="UI-th" style={{ width: '70px' }}>UOM</th>
                          <th className="UI-th UI-amount">Discount ({currency})</th>
                          {this.state.currency !== currency && <th className="UI-th UI-amount">Discount ({this.state.currency})</th>}
                          <th className="UI-th UI-amount">Total ({currency})</th>
                          {this.state.currency !== currency && <th className="UI-th UI-amount">Total ({this.state.currency})</th>}
                          {this.state.taxtype !== "NA" && this.state.taxrequired && (
                            <>
                              {this.state.taxtype === "GST" && ccountry === "India" ? (
                                this.state.gsttype === "INTRASTATE" ? (
                                  <>
                                    <th className="UI-th UI-amount">CGST</th>
                                    <th className="UI-th UI-amount">SGST</th>
                                    {this.state.currency !== currency && (
                                      <>
                                        <th className="UI-th UI-amount">CGST ({this.state.currency})</th>
                                        <th className="UI-th UI-amount">SGST ({this.state.currency})</th>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <th className="UI-th UI-amount">IGST</th>
                                    {this.state.currency !== currency && <th className="UI-th UI-amount">IGST ({this.state.currency})</th>}
                                  </>
                                )
                              ) : (
                                <>
                                  <th className="UI-th UI-amount">{this.state.taxtype}</th>
                                  {this.state.currency !== currency && <th className="UI-th UI-amount">{this.state.taxtype} ({this.state.currency})</th>}
                                </>
                              )}
                              <th className="UI-th UI-amount">Net Amount ({currency})</th>
                              {this.state.currency !== currency && <th className="UI-th UI-amount">Net Amount ({this.state.currency})</th>}
                            </>
                          )}
                          <th className="UI-th" style={{ width: '100px' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.accepteditems.map((row, index) => (
                          <tr key={index} className="UI-table-row">
                            <td className="UI-td">{row.name}</td>
                            {this.state.taxtype !== "NA" && <td className="UI-td">{row.hsn}</td>}
                            <td className="UI-td UI-amount">
                              <NumericFormat displayType="text" value={row.price} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                            </td>
                            {currency !== this.state.currency && (
                              <td className="UI-td UI-amount">
                                <NumericFormat displayType="text" value={row.ccprice} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                              </td>
                            )}
                            {currency !== this.state.currency && <td className="UI-td text-center">{row.pricevariance}</td>}
                            <td className="UI-td">{row.description}</td>
                            <td className="UI-td text-center">{parseFloat(row.quantity)}</td>
                            <td className="UI-td text-center">{row.uom}</td>
                            <td className="UI-td UI-amount">
                              <NumericFormat displayType="text" value={row.discountamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                              <span className="UI-helper-text"> ({row.discount}%)</span>
                            </td>
                            {this.state.currency !== currency && (
                              <td className="UI-td UI-amount">
                                <NumericFormat displayType="text" value={row.ccdiscountamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                <span className="UI-helper-text"> ({row.discount}%)</span>
                              </td>
                            )}
                            <td className="UI-td UI-amount">
                              <NumericFormat displayType="text" value={row.totalprice} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                            </td>
                            {this.state.currency !== currency && (
                              <td className="UI-td UI-amount">
                                <NumericFormat displayType="text" value={row.cctotalprice} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                              </td>
                            )}
                            {this.state.taxtype !== "NA" && this.state.taxrequired && (
                              <>
                                {this.state.taxtype === "GST" && this.state.gsttype === "INTRASTATE" ? (
                                  <>
                                    <td className="UI-td UI-amount">
                                      <NumericFormat displayType="text" value={row.taxamount * 0.5} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                      <span className="UI-helper-text"> ({row.tax / 2}%)</span>
                                    </td>
                                    <td className="UI-td UI-amount">
                                      <NumericFormat displayType="text" value={row.taxamount / 2} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                      <span className="UI-helper-text"> ({row.tax / 2}%)</span>
                                    </td>
                                    {this.state.currency !== currency && (
                                      <>
                                        <td className="UI-td UI-amount">
                                          <NumericFormat displayType="text" value={row.cctaxamount / 2} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                          <span className="UI-helper-text"> ({row.tax / 2}%)</span>
                                        </td>
                                        <td className="UI-td UI-amount">
                                          <NumericFormat displayType="text" value={row.cctaxamount / 2} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                          <span className="UI-helper-text"> ({row.tax / 2}%)</span>
                                        </td>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <td className="UI-td UI-amount">
                                      <NumericFormat displayType="text" value={row.taxamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                      <span className="UI-helper-text"> ({row.tax}%)</span>
                                    </td>
                                    {this.state.currency !== currency && (
                                      <td className="UI-td UI-amount">
                                        <NumericFormat displayType="text" value={row.cctaxamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                        <span className="UI-helper-text"> ({row.tax}%)</span>
                                      </td>
                                    )}
                                  </>
                                )}
                                <td className="UI-td UI-amount">
                                  <NumericFormat displayType="text" value={row.totalpricewtax} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                </td>
                                {this.state.currency !== currency && (
                                  <td className="UI-td UI-amount">
                                    <NumericFormat displayType="text" value={row.cctotalpricewtax} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                  </td>
                                )}
                              </>
                            )}
                            <td className="UI-td">
                              <div className="UI-action-buttons" style={{ display: "flex", alignItems: "center", justifyContent: 'center', gap: "10px" }}>
                                <button
                                  type="button"
                                  onClick={() => this.editItemFromList(index)}
                                  style={{ border: "none", background: "transparent", padding: 0, cursor: "pointer" }}
                                  onMouseEnter={() => this.setState({ isActionHovered: `editItem-${index}` })}
                                  onMouseLeave={() => this.setState({ isActionHovered: null })}
                                >
                                  <Tooltip title="Edit" arrow>
                                    <img
                                      src={EditIcon}
                                      alt="Edit"
                                      className={`UI-edit-icon ${this.state.isActionHovered === `editItem-${index}` ? 'UI-edit-icon-hover' : ''}`}
                                      style={{ width: '18px', height: '18px', objectFit: 'contain', transition: 'all 0.2s', ...(this.state.isActionHovered === `editItem-${index}` ? { filter: 'brightness(0) saturate(100%) invert(35%) sepia(99%) saturate(3015%) hue-rotate(205deg) brightness(97%) contrast(92%)' } : {}) }}
                                    />
                                  </Tooltip>
                                </button>
                                <button
                                  type="button"
                                  onClick={() => this.removeItemFromList(index)}
                                  style={{ border: "none", background: "transparent", padding: 0, cursor: "pointer" }}
                                  onMouseEnter={() => this.setState({ isActionHovered: `deleteItem-${index}` })}
                                  onMouseLeave={() => this.setState({ isActionHovered: null })}
                                >
                                  <Tooltip title="Delete" arrow>
                                    <img
                                      src={DeleteIcon}
                                      alt="Delete"
                                      className={`UI-delete-icon ${this.state.isActionHovered === `deleteItem-${index}` ? 'UI-delete-icon-hover' : ''}`}
                                    />
                                  </Tooltip>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <fieldset className="form-group col-md-12" />
                {this.state.pagename === "New Proforma Invoice" ? (
                  ""
                ) : (
                  <>
                    {(this.state.openingbalance !== null &&
                      this.state.openingbalance !== undefined &&
                      this.state.openingbalance > 0) || (this.state.adjustopen && this.state.invid !== -1) ? (
                      <>
                        <fieldset className="form-group col-md-12 m-0">
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.adjustopen}
                                  onChange={() =>
                                    this.setState({
                                      adjustopen:
                                        !this.state.adjustopen,
                                    })
                                  }
                                  name="adjustopen"
                                  color="primary"
                                />
                              }
                              className="text-info"
                              // disabled={
                              //   this.state.openingbalance >
                              //   this.state.totalinvoice
                              // }
                              label={`Adjust From Opening Balance (${this.state.openingbalance})`}
                            />
                          </FormGroup>
                        </fieldset>
                      </>
                    ) : (
                      ""
                    )}

                    {(this.state.debitamount !== null &&
                      this.state.debitamount !== undefined &&
                      this.state.debitamount > 0) || (this.state.adjustdebit && this.state.invid !== -1) ? (
                      <>
                        <fieldset className="form-group col-md-12 m-0">
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.adjustdebit}
                                  onChange={() =>
                                    this.setState({
                                      adjustdebit:
                                        !this.state.adjustdebit,
                                    })
                                  }
                                  name="adjustdebit"
                                  color="primary"
                                />
                              }
                              className="text-info"
                              label={`Adjust From Credit Amount (${this.state.debitamount})`}
                            />
                          </FormGroup>
                        </fieldset>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                )}

                {this.state.accepteditems.length > 0 && this.state.pagename !== "New Proforma Invoice" && (
                  <div className="UI-form-section" style={{ marginTop: '30px' }}>
                    <div style={{ display: 'flex', gap: '30px', alignItems: 'flex-start' }}>
                      {/* LEFT COLUMN: Charges & TCS Toggles/Inputs */}
                      <div style={{ flex: 2, minWidth: 0 }}>
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              cursor: 'pointer',
                              padding: '8px 16px',
                              borderRadius: '50px',
                              border: this.state.additionalChargesEnabled ? '1px solid #3574de' : '1px solid #e2e8f0',
                              backgroundColor: this.state.additionalChargesEnabled ? '#e4f0f7' : 'transparent',
                            }}
                            onClick={() => this.setState(prev => ({ additionalChargesEnabled: !prev.additionalChargesEnabled }))}
                          >
                            <SelectableRadio checked={this.state.additionalChargesEnabled} size="md" />
                            <span className="UI-label">Additional Charges</span>
                          </div>

                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              cursor: 'pointer',
                              padding: '8px 16px',
                              borderRadius: '50px',
                              border: this.state.insuranceEnabled ? '1px solid #3574de' : '1px solid #e2e8f0',
                              backgroundColor: this.state.insuranceEnabled ? '#e4f0f7' : 'transparent',
                            }}
                            onClick={() => this.setState(prev => ({ insuranceEnabled: !prev.insuranceEnabled }))}
                          >
                            <SelectableRadio checked={this.state.insuranceEnabled} size="md" />
                            <span className="UI-label">Add Insurance</span>
                          </div>

                          {ccountry === "India" && (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                cursor: 'pointer',
                                padding: '8px 16px',
                                borderRadius: '50px',
                                border: this.state.tcsEnabled ? '1px solid #3574de' : '1px solid #e2e8f0',
                                backgroundColor: this.state.tcsEnabled ? '#e4f0f7' : 'transparent',
                              }}
                              onClick={() => this.setState(prev => ({ tcsEnabled: !prev.tcsEnabled }))}
                            >
                              <SelectableRadio checked={this.state.tcsEnabled} size="md" />
                              <span className="UI-label">Add TCS Or TDS</span>
                            </div>
                          )}
                        </div>

                        {/* Additional Charges Forms */}
                        {this.state.additionalChargesEnabled && (
                          <div style={{ backgroundColor: '#f9fafb', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
                            <h4 className="UI-section-title" style={{ marginBottom: '15px' }}>Additional Charges</h4>
                            <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
                              <div className="UI-form-group">
                                <label className="UI-label">Nature/Type of Charges *</label>
                                <input
                                  type="text"
                                  className={`UI-input ${this.state.natureofcharge === '' && this.state.adderr ? 'UI-input-error' : ''}`}
                                  value={this.state.natureofcharge}
                                  onChange={(e) => this.setState({ natureofcharge: e.target.value })}
                                />
                              </div>
                              {/* <div className="UI-form-group">
                                <label className="UI-label">Amount *</label>
                                <div style={{ position: 'relative' }}>
                                  <input
                                    type="number"
                                    className={`UI-input ${this.state.additionalcharges === '' && this.state.adderr ? 'UI-input-error' : ''}`}
                                    value={this.state.additionalcharges}
                                    onChange={(e) => {
                                      const val = parseFloat(e.target.value) || 0;
                                      this.setState({
                                        additionalcharges: val,
                                        totaladditionalcharges: ((val * this.state.additionalchargestax) / 100 + val).toFixed(2),
                                        additionalchargestaxamount: (val * this.state.additionalchargestax) / 100,
                                      });
                                    }}
                                    style={{ paddingRight: '45px' }}
                                  />
                                  <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>{this.state.currency}</span>
                                </div>
                              </div> */}
                              {/* <div className="UI-form-group">
                                <label className="UI-label">Tax (%)</label>
                                <div style={{ position: 'relative' }}>
                                  <input
                                    type="number"
                                    className="UI-input"
                                    value={this.state.additionalchargestax}
                                    onChange={(e) => {
                                      const tax = parseFloat(e.target.value) || 0;
                                      this.setState({
                                        additionalchargestax: tax,
                                        additionalchargestaxamount: (this.state.additionalcharges * tax) / 100,
                                        totaladditionalcharges: ((this.state.additionalcharges * tax) / 100 + this.state.additionalcharges).toFixed(2),
                                      });
                                    }}
                                    style={{ paddingRight: '30px' }}
                                  />
                                  <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>%</span>
                                </div>
                              </div> */}
                              <TextfieldComponent label="Amount" value={this.state.additionalcharges} disabled={false} prefix={this.state.currency}
                                onChange={(e) => {
                                  const val = parseFloat(e.target.value) || 0;
                                  this.setState({
                                    additionalcharges: val,
                                    totaladditionalcharges: ((val * this.state.additionalchargestax) / 100 + val).toFixed(2),
                                    additionalchargestaxamount: (val * this.state.additionalchargestax) / 100,
                                  });
                                }} />
                              <TextfieldComponent label="Tax" value={this.state.additionalchargestax} disabled={false} prefix={"%"} onChange={(e) => {
                                const tax = parseFloat(e.target.value) || 0;
                                this.setState({
                                  additionalchargestax: tax,
                                  additionalchargestaxamount: (this.state.additionalcharges * tax) / 100,
                                  totaladditionalcharges: ((this.state.additionalcharges * tax) / 100 + this.state.additionalcharges).toFixed(2),
                                });
                              }} />
                              <TextfieldComponent label="Total Amount" value={this.state.totaladditionalcharges} disabled={true} prefix={this.state.currency} />
                              {/*<div className="UI-form-group">
                                 <label className="UI-label">Total Amount</label>
                                <div style={{ position: 'relative' }}>
                                <input type="text" className="UI-input" value={this.state.totaladditionalcharges} readOnly style={{ backgroundColor: '#f3f4f6',paddingRight:'30px' }} />
                                <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>%</span>
                                </div> 
                              </div>*/}
                            </div>
                            <button type="button" className="UI-btn UI-btn-primary" style={{ marginTop: '15px' }} onClick={this.AdditionalCharges}>
                              <i className="fas fa-plus"></i> Add Charge
                            </button>

                            {this.state.additionalchargeslist.length > 0 && (
                              <div className="UI-table-container" style={{ marginTop: '20px' }}>
                                <table className="UI-table">
                                  <thead className="UI-table-header">
                                    <tr>
                                      <th className="UI-th">Nature</th>
                                      <th className="UI-th UI-amount">Amount({this.state.basecurrency})</th>
                                      <th className="UI-th UI-amount">Amount({this.state.currency})</th>
                                      <th className="UI-th">Tax %</th>
                                      <th className="UI-th UI-amount">Total({this.state.basecurrency})</th>
                                      <th className="UI-th UI-amount">Total({this.state.currency})</th>
                                      <th className="UI-th UI-amount">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.additionalchargeslist.map((item, idx) => (
                                      <tr key={idx} className="UI-table-row">
                                        <td className="UI-td">{item.natureofcharge}</td>
                                        <td className="UI-td UI-amount">
                                          <NumericFormat value={item.additionalcharges} displayType="text" thousandSeparator decimalScale={2} fixedDecimalScale />
                                        </td>
                                        <td className="UI-td UI-amount">
                                          <NumericFormat value={item.ccadditionalcharges} displayType="text" thousandSeparator decimalScale={2} fixedDecimalScale />
                                        </td>
                                        <td className="UI-td">{item.additionalchargestax}%</td>
                                        <td className="UI-td UI-amount">
                                          <NumericFormat value={item.totaladditionalcharges} displayType="text" thousandSeparator decimalScale={2} fixedDecimalScale />
                                        </td>
                                        <td className="UI-td UI-amount">
                                          <NumericFormat value={item.cctotaladditionalcharges} displayType="text" thousandSeparator decimalScale={2} fixedDecimalScale />
                                        </td>
                                        <td className="UI-td">
                                          <Tooltip title="Remove" arrow>
                                            <img src={DeleteIcon} alt="Delete" style={{ width: '16px', cursor: 'pointer' }} onClick={() => this.RemoveAdditionalCharges(idx)} />
                                          </Tooltip>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        )}

                        {/* Insurance Section */}
                        {this.state.insuranceEnabled && (
                          <div style={{ backgroundColor: '#f9fafb', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
                            <h4 className="UI-section-title" style={{ marginBottom: '15px' }}>Insurance</h4>
                            <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px' }}>
                              <div className="UI-form-group">
                                <label className="UI-label">Insurance (%)</label>
                                <input
                                  type="number"
                                  className="UI-input"
                                  value={this.state.insurance}
                                  onChange={(e) => {
                                    const val = parseFloat(e.target.value) || 0;
                                    const amt = (this.state.totalinvoice * val) / 100;
                                    this.setState({ insurance: val }, () => this.recomputeTotals());
                                  }}
                                />
                              </div>
                              <div className="UI-form-group">
                                <label className="UI-label">Tax (%)</label>
                                <input
                                  type="number"
                                  className="UI-input"
                                  value={this.state.insurancetax}
                                  onChange={(e) => {
                                    const tax = parseFloat(e.target.value) || 0;
                                    this.setState({ insurancetax: tax }, () => this.recomputeTotals());
                                  }}
                                />
                              </div>
                              {/* <div className="UI-form-group">
                                <label className="UI-label">Total Insurance</label>
                                <input type="text" className="UI-input" value={this.state.totalinsuranceamount} readOnly style={{ backgroundColor: '#f3f4f6' }} />
                              </div> */}
                              <TextfieldComponent label="Total Insurance" value={this.state.totalinsuranceamount} disabled={true} prefix={this.state.currency} />
                            </div>
                          </div>
                        )}

                        {/* TCS/TDS Section */}
                        {this.state.tcsEnabled && (
                          <div style={{ backgroundColor: '#f9fafb', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                              <span className="UI-label" style={{ marginRight: '10px' }}>TDS</span>
                              <OSSwitch
                                checked={this.state.isTCSMode}
                                onChange={(checked) => this.setState({ isTCSMode: checked })}
                              />
                              <span className="UI-label" style={{ marginLeft: '10px' }}>TCS</span>
                            </div>
                            <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px' }}>
                              <div className="UI-form-group">
                                <label className="UI-label">Amount on which {this.state.isTCSMode ? 'TCS' : 'TDS'} applies</label>
                                <input
                                  type="number"
                                  className="UI-input"
                                  value={this.state.tcsableamount}
                                  onChange={(e) => {
                                    const val = parseFloat(e.target.value) || 0;
                                    this.setState({
                                      tcsableamount: val,
                                      tcsamount: ((val * this.state.tcs) / 100).toFixed(2),
                                    });
                                  }}
                                />
                              </div>
                              <div className="UI-form-group">
                                <label className="UI-label">{this.state.isTCSMode ? 'TCS' : 'TDS'} (%)</label>
                                <input
                                  type="number"
                                  className="UI-input"
                                  value={this.state.tcs}
                                  onChange={(e) => {
                                    const val = parseFloat(e.target.value) || 0;
                                    this.setState({
                                      tcs: val,
                                      tcsamount: ((this.state.tcsableamount * val) / 100).toFixed(2),
                                    });
                                  }}
                                />
                              </div>
                              <TextfieldComponent label={this.state.isTCSMode ? 'TCS Amount' : 'TDS Amount'} value={this.state.tcsamount} disabled={true} prefix={this.state.currency} />

                            </div>
                          </div>
                        )}
                      </div>

                      {/* RIGHT COLUMN: Sticky Subtotal Panel */}
                      <div
                        style={{
                          flex: 1,
                          minWidth: 0,
                          backgroundColor: '#f4f4f4',
                          padding: '20px',
                          borderRadius: '4px',
                          alignSelf: 'flex-start',
                          position: 'sticky',
                          top: '20px',          // keeps it 20px from the top of the viewport while its parent is visible
                          zIndex: 1,
                        }}
                      >
                        <h4 style={{ marginTop: 0, marginBottom: '16px' }}>Subtotal</h4>

                        {/* Subtotal rows – using computed totals from state */}
                        <div style={{ marginBottom: '12px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                            <span>Subtotal (Items/Services):</span>
                            <span>
                              <NumericFormat
                                displayType="text"
                                value={this.state.subtotal || 0}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator
                                thousandsGroupStyle={thousandsdisplay}
                              />{' '}
                              {this.state.currency}
                            </span>
                          </div>
                          {this.state.currency !== this.state.basecurrency && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '0.9em', color: '#555' }}>
                              <span>Subtotal ({this.state.basecurrency}):</span>
                              <span>
                                <NumericFormat
                                  displayType="text"
                                  value={this.state.ccsubtotal || 0}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator
                                  thousandsGroupStyle={thousandsdisplay}
                                />{' '}
                                {this.state.basecurrency}
                              </span>
                            </div>
                          )}
                        </div>

                        {this.state.taxrequired && (
                          <div style={{ marginBottom: '12px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                              <span>Tax Total:</span>
                              <span>
                                <NumericFormat
                                  displayType="text"
                                  value={this.state.taxTotal || 0}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator
                                  thousandsGroupStyle={thousandsdisplay}
                                />{' '}
                                {this.state.currency}
                              </span>
                            </div>
                            {this.state.currency !== this.state.basecurrency && (
                              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '0.9em', color: '#555' }}>
                                <span>Tax Total ({this.state.basecurrency}):</span>
                                <span>
                                  <NumericFormat
                                    displayType="text"
                                    value={this.state.cctaxTotal || 0}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator
                                    thousandsGroupStyle={thousandsdisplay}
                                  />{' '}
                                  {this.state.basecurrency}
                                </span>
                              </div>
                            )}
                          </div>
                        )}

                        {this.state.additionalChargesTotal > 0 && (
                          <div style={{ marginBottom: '12px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                              <span>Additional Charges:</span>
                              <span>
                                <NumericFormat
                                  displayType="text"
                                  value={this.state.additionalChargesTotal}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator
                                  thousandsGroupStyle={thousandsdisplay}
                                />{' '}
                                {this.state.currency}
                              </span>
                            </div>
                            {this.state.currency !== this.state.basecurrency && (
                              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '0.9em', color: '#555' }}>
                                <span>Additional Charges ({this.state.basecurrency}):</span>
                                <span>
                                  <NumericFormat
                                    displayType="text"
                                    value={this.state.ccadditionalChargesTotal}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator
                                    thousandsGroupStyle={thousandsdisplay}
                                  />{' '}
                                  {this.state.basecurrency}
                                </span>
                              </div>
                            )}
                          </div>
                        )}

                        {this.state.insuranceEnabled && this.state.insuranceTotal > 0 && (
                          <div style={{ marginBottom: '12px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                              <span>Insurance Total:</span>
                              <span>
                                <NumericFormat
                                  displayType="text"
                                  value={this.state.insuranceTotal}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator
                                  thousandsGroupStyle={thousandsdisplay}
                                />{' '}
                                {this.state.currency}
                              </span>
                            </div>
                            {this.state.currency !== this.state.basecurrency && (
                              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '0.9em', color: '#555' }}>
                                <span>Insurance Total ({this.state.basecurrency}):</span>
                                <span>
                                  <NumericFormat
                                    displayType="text"
                                    value={this.state.insuranceTotal * this.state.curconversionrate}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator
                                    thousandsGroupStyle={thousandsdisplay}
                                  />{' '}
                                  {this.state.basecurrency}
                                </span>
                              </div>
                            )}
                          </div>
                        )}

                        {this.state.tcsEnabled && (
                          <div style={{ marginBottom: '12px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                              <span>{this.state.isTCSMode ? 'TCS' : 'TDS'} Amount:</span>
                              <span>
                                <NumericFormat
                                  displayType="text"
                                  value={this.state.isTCSMode ? this.state.tcsTotal : this.state.tdsTotal}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator
                                  thousandsGroupStyle={thousandsdisplay}
                                />{' '}
                                {this.state.currency}
                              </span>
                            </div>
                            {/* Optionally show base currency equivalent if needed */}
                          </div>
                        )}

                        <hr style={{ margin: '16px 0' }} />

                        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '1.1em' }}>
                          <span>Grand Total:</span>
                          <span>
                            <NumericFormat
                              displayType="text"
                              value={this.state.grandtotal}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator
                              thousandsGroupStyle={thousandsdisplay}
                            />{' '}
                            {this.state.currency}
                          </span>
                        </div>
                        {this.state.currency !== this.state.basecurrency && (
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9em', color: '#555', marginTop: '4px' }}>
                            <span>Grand Total ({this.state.basecurrency}):</span>
                            <span>
                              <NumericFormat
                                displayType="text"
                                value={this.state.ccgrandtotal}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator
                                thousandsGroupStyle={thousandsdisplay}
                              />{' '}
                              {this.state.basecurrency}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {(this.state.accepteditems.length > 0) && this.state.pagename !== "New Proforma Invoice" && (
                  <div className="UI-form-section" style={{ marginTop: '30px' }}>
                    {/* Address type selector - tabs */}
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
                      {this.state.sotype !== 2 && (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            cursor: 'pointer',
                            padding: '8px 16px',
                            borderRadius: '50px',
                            border: this.state.addressType === 'dispatch' ? '1px solid #3574de' : '1px solid #e2e8f0',
                            backgroundColor: this.state.addressType === 'dispatch' ? '#e4f0f7' : 'transparent',
                          }}
                          onClick={() => this.setState({ addressType: 'dispatch' })}
                        >
                          <SelectableRadio checked={this.state.addressType === 'dispatch'} size="md" />
                          <span className="UI-label">Dispatch Details</span>
                        </div>
                      )}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          cursor: 'pointer',
                          padding: '8px 16px',
                          borderRadius: '50px',
                          border: this.state.addressType === 'billing' ? '1px solid #3574de' : '1px solid #e2e8f0',
                          backgroundColor: this.state.addressType === 'billing' ? '#e4f0f7' : 'transparent',
                        }}
                        onClick={() => this.setState({ addressType: 'billing' })}
                      >
                        <SelectableRadio checked={this.state.addressType === 'billing'} size="md" />
                        <span className="UI-label">Billing Details</span>
                      </div>
                      {this.state.sotype !== 2 && (
                        <>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              cursor: 'pointer',
                              padding: '8px 16px',
                              borderRadius: '50px',
                              border: this.state.addressType === 'shipping' ? '1px solid #3574de' : '1px solid #e2e8f0',
                              backgroundColor: this.state.addressType === 'shipping' ? '#e4f0f7' : 'transparent',
                            }}
                            onClick={() => this.setState({ addressType: 'shipping' })}
                          >
                            <SelectableRadio checked={this.state.addressType === 'shipping'} size="md" />
                            <span className="UI-label">Shipping Details</span>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              cursor: 'pointer',
                              padding: '8px 16px',
                              borderRadius: '50px',
                              border: this.state.addressType === 'transport' ? '1px solid #3574de' : '1px solid #e2e8f0',
                              backgroundColor: this.state.addressType === 'transport' ? '#e4f0f7' : 'transparent',
                            }}
                            onClick={() => this.setState({ addressType: 'transport' })}
                          >
                            <SelectableRadio checked={this.state.addressType === 'transport'} size="md" />
                            <span className="UI-label">Transport Details</span>
                          </div>
                        </>
                      )}
                    </div>

                    <div style={{ backgroundColor: '#f9f9f9', padding: '24px', marginBottom: '16px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                      {/* Dispatch Details Tab */}
                      {this.state.addressType === 'dispatch' && (
                        <div className="UI-form-section-inner">
                          <div className="UI-form-group" style={{ marginBottom: '16px', marginLeft: '10px' }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.defaultdisadd}
                                  onChange={this.handleDefaultdisadd}
                                  icon={<SelectableRadio checked={false} />}
                                  checkedIcon={<SelectableRadio checked={true} />}
                                  sx={{ p: 0 }}
                                />
                              }
                              label="Default dispatch address"
                              className="UI-label"
                              sx={{ gap: '8px' }}
                            />
                          </div>
                          <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                            <div className="UI-form-group">
                              <label className="UI-label">Full Name</label>
                              <input
                                type="text"
                                className={`UI-input ${this.state.disname === "" && this.state.err ? 'UI-input-error' : ''}`}
                                value={this.state.disname}
                                onChange={(e) => this.setState({ disname: e.target.value, err: false })}
                              />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Phone Number</label>
                              <input
                                type="text"
                                className={`UI-input ${this.state.disphoneno === "" && this.state.err ? 'UI-input-error' : ''}`}
                                value={this.state.disphoneno}
                                onChange={(e) => this.setState({ disphoneno: e.target.value, err: false })}
                              />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Pincode</label>
                              <input
                                type="number"
                                className={`UI-input ${this.state.dispincode === "" && this.state.err ? 'UI-input-error' : ''}`}
                                value={this.state.dispincode}
                                onChange={(e) => this.setState({ dispincode: e.target.value, err: false })}
                              />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Address</label>
                              <input
                                type="text"
                                className={`UI-input ${this.state.dishouseno === "" && this.state.err ? 'UI-input-error' : ''}`}
                                value={this.state.dishouseno}
                                onChange={(e) => this.setState({ dishouseno: e.target.value, err: false })}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Billing Details Tab */}
                      {(this.state.addressType === 'billing' || (this.state.sotype === 2 && this.state.addressType !== 'billing')) && (
                        <div className="UI-form-section-inner">
                          <h5 className="UI-section-title" style={{ marginBottom: '20px' }}>Billing Address</h5>
                          <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                            <div className="UI-form-group">
                              <label className="UI-label">Full Name</label>
                              <input type="text" className="UI-input UI-input-disabled" value={this.state.name} disabled />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Phone Number</label>
                              <input type="text" className="UI-input UI-input-disabled" value={this.state.phoneno} disabled />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Pincode</label>
                              <input type="text" className="UI-input UI-input-disabled" value={this.state.pincode} disabled />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">City</label>
                              <input type="text" className="UI-input UI-input-disabled" value={this.state.city} disabled />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">State</label>
                              <input type="text" className="UI-input UI-input-disabled" value={this.state.state} disabled />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Country</label>
                              <input type="text" className="UI-input UI-input-disabled" value={this.state.country} disabled />
                            </div>
                            <div className="UI-form-group" style={{ gridColumn: 'span 2' }}>
                              <label className="UI-label">Address</label>
                              <input type="text" className="UI-input UI-input-disabled" value={this.state.houseno} disabled />
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Shipping Details Tab */}
                      {this.state.addressType === 'shipping' && this.state.sotype !== 2 && (
                        <div className="UI-form-section-inner">
                          <div className="UI-form-group" style={{ marginBottom: '16px', marginLeft: '10px' }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.defaultadd}
                                  onChange={this.handleDefaultadd}
                                  icon={<SelectableRadio checked={false} />}
                                  checkedIcon={<SelectableRadio checked={true} />}
                                  sx={{ p: 0 }}
                                />
                              }
                              label="Same as billing address"
                              className="UI-label"
                              sx={{ gap: '8px' }}
                            />
                          </div>
                          <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                            <div className="UI-form-group">
                              <label className="UI-label">Full Name</label>
                              <input
                                type="text"
                                className={`UI-input ${this.state.name === "" && this.state.err ? 'UI-input-error' : ''}`}
                                value={this.state.name}
                                onChange={(e) => this.setState({ name: e.target.value, err: false })}
                              />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Phone Number</label>
                              <input
                                type="text"
                                className={`UI-input ${this.state.phoneno === "" && this.state.err ? 'UI-input-error' : ''}`}
                                value={this.state.phoneno}
                                onChange={(e) => this.setState({ phoneno: e.target.value, err: false })}
                              />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Pincode</label>
                              <input
                                type="number"
                                className={`UI-input ${this.state.pincode === "" && this.state.err ? 'UI-input-error' : ''}`}
                                value={this.state.pincode}
                                onChange={(e) => this.setState({ pincode: e.target.value, err: false })}
                              />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Address</label>
                              <input
                                type="text"
                                className={`UI-input ${this.state.houseno === "" && this.state.err ? 'UI-input-error' : ''}`}
                                value={this.state.houseno}
                                onChange={(e) => this.setState({ houseno: e.target.value, err: false })}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Transport Details Tab */}
                      {this.state.addressType === 'transport' && this.state.sotype !== 2 && (
                        <div className="UI-form-section-inner">
                          <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                            <div className="UI-form-group">
                              <label className="UI-label">Distance (KM)</label>
                              <input type="number" className="UI-input" value={this.state.distance} onChange={(e) => this.setState({ distance: e.target.value })} />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Transporter ID</label>
                              <input type="text" className="UI-input" value={this.state.transporterid} onChange={(e) => this.setState({ transporterid: e.target.value })} />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Transporter Name</label>
                              <input type="text" className="UI-input" value={this.state.transportername} onChange={(e) => this.setState({ transportername: e.target.value })} />
                            </div>
                            <div className="UI-form-group">
                              <label className="UI-label">Vehicle Number</label>
                              <input type="text" className="UI-input" value={this.state.vehiclenum} onChange={(e) => this.setState({ vehiclenum: e.target.value })} />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}



                <div className="UI-form-section" style={{ marginTop: '20px' }}>
                  <div className="UI-form-grid" style={{ gridTemplateColumns: '1fr' }}>
                    <div className="UI-form-group">
                      <label className="UI-label">Remarks</label>
                      <textarea
                        className="UI-input"
                        rows={3}
                        value={this.state.invoiceremarks}
                        onChange={(e) => this.setState({ invoiceremarks: e.target.value })}
                        placeholder="Enter any additional remarks..."
                      />
                    </div>
                  </div>
                </div>

                {this.state.iscomposite && (
                  <div className="UI-helper-text" style={{ color: '#d32f2f', margin: '16px 0' }}>
                    Note: Reverse GST will be applicable on this invoice
                  </div>
                )}

                <div className="UI-btn-actions" style={{ marginTop: '30px', display: 'flex', gap: '12px', alignItems: 'center' }}>
                  {(this.state.sotype === 1 || (this.state.invtype === "Direct Invoice" && this.state.servicecostwttax > 0)) ? (
                    <button
                      type="button"
                      className="UI-btn UI-btn-primary"
                      onClick={this.handlesubmit}
                      disabled={this.state.loader}
                    >
                      {this.state.loader ? (
                        <><span className="UI-spinner-small"></span> Saving...</>
                      ) : (
                        <><i className="fas fa-save"></i> Save & send for approval</>
                      )}
                    </button>
                  ) : (this.state.accepteditems.length === 0 && this.state.completed === "") ? (
                    <button className="UI-btn UI-btn-primary" disabled>
                      <i className="fas fa-save"></i> Save & send for approval
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="UI-btn UI-btn-primary"
                      onClick={this.handlesubmit}
                      disabled={this.state.loader}
                    >
                      {this.state.loader ? (
                        <><span className="UI-spinner-small"></span> Saving...</>
                      ) : (
                        <><i className="fas fa-save"></i> Save & send for approval</>
                      )}
                    </button>
                  )}

                  <Link
                    to={{ pathname: "/salesinvoice" }}
                    state={{
                      message: "",
                      type: this.state.pagename === "New Proforma Invoice" ? "Proforma Invoice" : "Tax Invoice",
                    }}
                    className="UI-btn UI-btn-outline"
                  >
                    <i className="fas fa-times"></i> Cancel
                  </Link>
                </div>

                {this.state.errormsg.length > 0 && (
                  <div className="UI-error-text" style={{ marginTop: '16px' }}>
                    {typeof this.state.errormsg === "string"
                      ? this.state.errormsg
                      : this.state.errormsg.map((e, i) => e.ErrorMessage + (i < this.state.errormsg.length - 1 ? ", " : ""))}
                  </div>
                )}
              </Form>
            )}
          </Formik>

          <Modal
            show={this.state.quantitywindow}
            onHide={() => this.setState({ quantitywindow: false })}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Select Quantity</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '20px' }}>
                <div className="UI-form-group">
                  <label className="UI-label">Pending Quantity</label>
                  <div className="UI-static-value" style={{ padding: '8px', backgroundColor: '#f9f9f9', borderRadius: '4px', border: '1px solid #eee' }}>
                    {this.state.pendingquantity}
                  </div>
                </div>
                <div className="UI-form-group">
                  <label className="UI-label">Total Quantity</label>
                  <div className="UI-static-value" style={{ padding: '8px', backgroundColor: '#f9f9f9', borderRadius: '4px', border: '1px solid #eee' }}>
                    {this.state.quantity}
                  </div>
                </div>
              </div>

              {this.state.itemquantitylist.length === 0 ? (
                <div className="UI-helper-text" style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                  Out of Stock
                </div>
              ) : (
                <div className="UI-table-container">
                  <table className="UI-table">
                    <thead className="UI-table-header">
                      <tr>
                        <th className="UI-th" style={{ textAlign: 'center' }}>Batch Id</th>
                        <th className="UI-th" style={{ textAlign: 'right' }}>Price</th>
                        <th className="UI-th" style={{ textAlign: 'center' }}>Date</th>
                        <th className="UI-th" style={{ textAlign: 'center' }}>Available Quantity</th>
                        <th className="UI-th">Enter Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.itemquantitylist.map((e, i) => (
                        <tr key={i}>
                          <td className="UI-td" style={{ textAlign: 'center' }}>{e.batchid}</td>
                          <td className="UI-td" style={{ textAlign: 'right' }}>
                            <NumericFormat
                              displayType="text"
                              value={e.price}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator
                              thousandsGroupStyle={thousandsdisplay}
                            />
                          </td>
                          <td className="UI-td" style={{ textAlign: 'center' }}>
                            {moment(e.createdAt).format("DD-MM-YYYY hh:mm")}
                          </td>
                          <td className="UI-td" style={{ textAlign: 'center' }}>{e.currentstock}</td>
                          <td className="UI-td">
                            <input
                              type="number"
                              className="UI-input"
                              value={e.enteredquantity}
                              onChange={(evt) => this.handleQuantityChange(evt.target.value, i)}
                              min="0"
                              max={e.currentstock}
                              style={{
                                borderColor: (e.enteredquantity > e.currentstock || e.enteredquantity < 0) ? '#d32f2f' : '#ddd'
                              }}
                            />
                            {(e.enteredquantity > e.currentstock) && (
                              <div style={{ color: '#d32f2f', fontSize: '11px', marginTop: '4px' }}>Exceeds Available</div>
                            )}
                            {(e.enteredquantity < 0) && (
                              <div style={{ color: '#d32f2f', fontSize: '11px', marginTop: '4px' }}>Min 0</div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <div className="UI-btn-actions" style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                <button className="UI-btn UI-btn-primary" onClick={this.handleSaveQuantity}>
                  Submit
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div >
    );
  }
}

export default withRouter(NonInvInvoice);
